import {
  Avatar,
  Box,
  Button,
  Flex,
  Heading,
  ListItem,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
  UnorderedList,
  useColorModeValue,
} from "@chakra-ui/react";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import NotFound from "assets/svg/not-found.svg";
import Searchicon from "assets/svg/search-icon.svg";
import axios from "axios";
import FileViewer from "react-file-viewer";
import CommonSubmissionFile from "components/CommonSubmissionFile/CommonSubmissionFile";
import NoteSubmissionModel from "components/Commoncomponent/Note/NoteSubmissionModel";
import CustomizeColumns from "components/CustomizeColumns/CustomizeColumns";
import EditCandidateModal from "components/EditCandidateModal/EditCandidateModal";
import EditSubmissionStatusModel from "components/EditSubmissionStatusModel/EditSubmissionStatusModel";
import SearchJobModel from "components/SearchJobModel/SearchJobModel";
import ResumePreviewModal from 'components/Commoncomponent/ResumePreviewModal'
import DeleteModal from "components/Commoncomponent/DeleteModal";
import { Country } from "country-state-city";
import * as FileSaver from "file-saver";
import { useFormik } from "formik";
import { MDBContainer } from "mdb-react-ui-kit";
import moment from "moment";
import { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ListGroup from "react-bootstrap/ListGroup";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useCookies } from "react-cookie";
import "react-phone-input-2/lib/style.css";
import { useParams } from "react-router";
import { Link, useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { formatToDateISO, userActivity } from "../../Utils";
import config from "../../config";
import {
  defaultSubmHeaderOrders,
  submCandidateHeaderShow,
} from "../../constant";
import ComposeMailForm from "./ComposeMailForm";
import Loader from "./Loader";
import Submissionform from "./Submissionform";
import "./org.css";

//Formik Schema For edit Candidate
const editCandidate = Yup.object().shape({
  firstName: Yup.string().trim().required("Enter first name"),
  lastName: Yup.string().trim().required("Enter last name"),
  email: Yup.string().email().required("Enter email address"),
  phone: Yup.string().required("Please enter mobile number"),
  password: Yup.string(),
  status: Yup.string().required("Please select status"),
  skill: Yup.string().required("Please add required skill for job"),
  experiance: Yup.string().required("Please select experience"),
  designation: Yup.string().required("Please select designation"),
  PancardNumber: Yup.string(),
  AadharcardNumber: Yup.string(),
  dateofBirth: Yup.string(),
  gender: Yup.string().required("Please select gender"),
  country: Yup.string().required("Please select country"),
  state: Yup.string().required("Please select state"),
  city: Yup.string().required("Please select city"),
  address: Yup.string(),
  pincode: Yup.string(),
  source: Yup.string().required("Please select source"),
  currentCandidateCTCType: Yup.string(),
  currentCandidateCTC: Yup.string(),
  expectedCandidateCTCType: Yup.string(),
  expectedCandidateCTC: Yup.string(),
  noticePeriod: Yup.string(),
  candidateStatus: Yup.string(),
  file: Yup.mixed().required("File is required"),
  industry: Yup.string().required("Please select industry"),
  linkedIn: Yup.string(),
});

function Candidateview() {
  const history = useHistory();
  const handleGoBack = () => {
    history?.goBack();
  };
  const [parsedObjectives, setParsedObjectives] = useState([]);

  const [cookie] = useCookies(["role", "id", "token"]);
  const candidate_ownerName = localStorage?.getItem("candidate_ownerName");
  const userId = cookie.id;
  const userRole = cookie?.role;
  const [teamData, setTeamData] = useState([]);
  const [moduleData, setModuleData] = useState({});
  const [candidateStatus, setCandidateStatus] = useState([]);
  const [submissionModuleData, setSubmissionModuleData] = useState({});
  const [interviewscheduleModuleData, setInterviewscheduleModuleData] =
    useState({});
  const [activityStatus, setActivityStatus] = useState('')
  const [loadingResumeScreening, setLoadingResumeScreening] = useState(false);
  const [parseResumeConclusion, setparseResumeConclusion] = useState("");
  const [parsePercentage, setParsePercentage] = useState("");
  const [parseAge, setParseAge] = useState("");
  const [loading, setLoading] = useState(true);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [candidate, setCandidate] = useState({});
  const [displaycandidate, setDisplayCandidate] = useState([]);
  const [applicationStatus, setApplicationStatus] = useState([]);
  const [educationDetails, setEducationDetails] = useState([]);
  const [workExperience, setWorkExperience] = useState([]);
  const [referenceDetail, setReferenceDetail] = useState([]);
  const [candidateSubmission, setCandidateSubmission] = useState([]);
  const [displaycandidateSubmission, setDisplayCandidateSubmission] = useState(
    []
  );
  const [isFilterActiveJobId, setIsFilterActiveJobId] = useState(false);
  const [searchJobId, setSearchJobId] = useState("")
  const [searchSubmissionId, setSearchSubmissionId] = useState([]);
  const [isFilterActiveSubmissionId, setIsFilterActiveSubmissionId] = useState(false)
  const [candidateLoading, setCandidateLoading] = useState(false);
  const [resumeFilePath, setResumeFilePath] = useState(null);
  const [showResumeDetails, setShowResumeDetails] = useState(true);
  const toggleResumeDetails = () => {
    setShowResumeDetails((prevShow) => !prevShow);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [submissionPreview, SetSubmissionPreview] = useState(false);
  const [objectURL, setObjectURL] = useState("");
  const [submission, setSubmission] = useState({
    jobId: "",
    clientId: "",
    candidateId: "",
    Questions: "",
    email: "",
    skill: "",
    clientemail: "",
    status: "Internal-Submitted",
    currentCandidateCTCType: "",
    currentCandidateCTC: "",
    expectedCandidateCTCType: "",
    expectedCandidateCTC: "",
    noticePeriod: "",
    relevantExperiance: "",
    availability: "",
    engagement: "",
    locationPreference: "",
    QnA: [],
    file: "",
    fileName: "",
    filePath: "",
    submitterName: "",
  });
  const [resumeid, setId] = useState("");
  let { id } = useParams();

  const location = useLocation();
  const routers = location.pathname;
  const parts = routers.split("/");
  const router = parts.slice(1, -1).join("/");

  const queryParams = new URLSearchParams(location?.search);
  const iParam = queryParams?.get("i");

  const [pipelinedCandidates, setPipelinedCandidates] = useState([]);
  const [interviewedCandidates, setInterviewedCandidates] = useState([]);
  const [displayinterviewedCandidates, setDisplayInterviewedCandidates] =
    useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [acceptedCandidates, setAcceptedCandidates] = useState([]);
  const [onboardedCandidates, setOnboardedCandidates] = useState([]);
  const [interviewfeedbackCandidates, setInterviewfeedbackCandidates] =
    useState([]);

  const [searchAllfields, setSearchAllfields] = useState("");
  const [searchJobTitle, setSearchJobTitle] = useState("");
  const [searchJobContactName, setSearchJobContactName] = useState("");
  const [searchJobOwner, setSearchJobOwner] = useState(null);
  const [searchJobClient, setSearchJobClient] = useState(null);
  const [searchJobBranch, setSearchJobBranch] = useState(null);
  const [searchJobCity, setSearchJobCity] = useState("");
  const [jobScreeningId, setJobScreeningId] = useState([]);
  const [jobSearchActiveField, setJobSearchActiveField] = useState({
    name: "",
    value: "",
  });
  const [searchJobLoading, setSearchJobLoading] = useState(false);

  const [activity, SetActivity] = useState([]);
  const [jobposts, setJobposts] = useState([]);
  const [searchJob, SetSearchJob] = useState(false);
  const [searchjob, setSearchJob] = useState("");
  const [submissionpage, setSubmissionPage] = useState(0);
  const [rowsPerSubmissionPage, setRowsPerSubmissionPage] = useState(10);
  const [candidateSubmissionpage, setCandidateSubmissionPage] = useState(0);
  const [rowsPerCandidateSubmissionPage, setRowsPerCandidateSubmissionPage] =
    useState(10);
  const [submitSubmission, SetSubmitSubmission] = useState(false);
  const [jobtitle, Setjobtitle] = useState([]);
  const [matchingSkills, setMatchingSkills] = useState([]);
  const [missingSkills, setMissingSkills] = useState([]);
  const [ParsedSkills, setParsedSkills] = useState([]);
  const [clientJobs, setClientJobs] = useState([]);

  const [submissionid, setSubmissionId] = useState(false);
  const [editSubmission, SetEditSubmission] = useState(false);
  const [removeSubmission, SetRemoveSubmission] = useState(false);
  const [editSubmissionStatus, SetEditSubmissionStatus] = useState(false);

  const [ViewSendMail, SetSendMailShow] = useState(false);
  const [checked, SetIschecked] = useState([]);
  const [toemail, SetToemail] = useState("");
  const [ccemail, SetCcemail] = useState("");
  const [bccemail, SetBccemail] = useState("");
  const [subject, SetSubject] = useState("");
  const [mailMessage, SetMailMessage] = useState("");

  const [ViewEdit, SetEditShow] = useState(false);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");
  const [filePath, setFilePath] = useState("");
  const [selectedCountry, setSelectedCountry] = useState({
    name: "India",
    isoCode: "IN",
  });
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [eductionFields, setEductionFields] = useState([
    {
      institutename: "",
      degree: "",
      startDate: "",
      endDate: "",
      percentage: "",
      category: "",
    },
  ]);
  const india = Country.getCountryByCode("IN");
  const [workExperienceFields, setWorkexperienceFields] = useState([
    {
      companyname: "",
      designation: "",
      startDate: "",
      endDate: "",
      country: india.name,
      state: "",
      city: "",
      countryCode: india.isoCode,
      stateCode: "",
    },
  ]);
  const [referenceFields, setReferenceFields] = useState([
    {
      referenceType: "",
      referenceName: "",
      companyName: "",
      designation: "",
      email: "",
      phone: "",
    },
  ]);
  const [selectedWorkCountry, setSelectedWorkCountry] = useState({
    name: "India",
    isoCode: "IN",
  });
  const [selectedWorkState, setSelectedWorkState] = useState(null);
  const [selectedWorkCity, setSelectedorkCity] = useState(null);

  const [sourceData, setSourceData] = useState([]);

  const [getnotes, setGetNotes] = useState([]);
  const [note, setNote] = useState({});
  const [searchNote, setSearchNote] = useState("");
  const [notesLoading, setNotesLoading] = useState(false);

  const [oldJobId, setOldJobId] = useState("");
  const [candidateNote, setCandidateNote] = useState(false);
  const [ViewSubmheaderOrders, setViewSubmheaderOrders] = useState(false);
  const [submheaderOrders, setSubmHeaderOrders] = useState(
    JSON.parse(localStorage.getItem("submheaderOrders")) ||
    defaultSubmHeaderOrders.filter(
      (header) => submCandidateHeaderShow[header]
    )
  );
  const [displaySubmheaderOrders, setDisplaySubmheaderOrders] = useState(
    defaultSubmHeaderOrders
  );
  const [defaultDisplaySubmHeaderOrders, setDefaultDisplaySubmHeaderOrders] =
    useState(
      JSON.parse(localStorage.getItem("defaultDisplaySubmHeaderOrders")) ||
      submCandidateHeaderShow
    );
  const handleSubmHeaderOrdersshow = () => {
    setViewSubmheaderOrders(true);
  };
  const handleSubmHeaderOrdersClose = () => {
    setViewSubmheaderOrders(false);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(displaySubmheaderOrders);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setDisplaySubmheaderOrders(items);
  };

  const handleApplyClick = () => {
    const temp = Object.keys(defaultDisplaySubmHeaderOrders).filter(
      (key) => defaultDisplaySubmHeaderOrders[key]
    );
    const main = displaySubmheaderOrders.filter((key) => temp.includes(key));
    setSubmHeaderOrders(main);
    toast.success("Columns change successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    handleSubmHeaderOrdersClose();
  };
  const handleCheckboxChange = (key, isChecked) => {
    const temp = JSON.parse(JSON.stringify(defaultDisplaySubmHeaderOrders));
    temp[key] = isChecked;
    setDefaultDisplaySubmHeaderOrders(temp);
  };

  const handleCandidateNoteShow = () => {
    setCandidateNote(true);
  };
  const handleCandidateNoteClose = () => {
    setCandidateNote(false);
  };

  const getCandidatNotes = async (id) => {
    try {
      setNotesLoading(true);
      if (id) {
        const response = await axios.get(
          `${config?.apiUrl}/api/get_Candidate_Note/${id}`
        );
        const notedata = response.data.data;
        setGetNotes(notedata);
        setNotesLoading(false);
      } else {
        setNotesLoading(false);
      }
    } catch (error) {
      setNotesLoading(false);
      toast.error(
        error?.message ||
        "Something happened wrong, please try again after sometime.",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  const filename = "Submissions";

  const exportSubmissions = (submissions, filename) => {
    // Check if any submission is selected
    if (checked.length === 0) {
      toast.error("Please select at least one user to export information", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    // Define file properties
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    // Filter submissions based on checked IDs
    const filteredSubmissions = submissions
      .filter((candidate) =>
        checked.some((check) => check.id === candidate._id)
      )
      .map((candidate) => {
        const filteredVal = {};

        displaySubmheaderOrders.forEach((field) => {
          const value = defaultDisplaySubmHeaderOrders[field];
          if (value) {
            switch (field) {
              case "email":
                filteredVal["Email"] = candidate.candidateId?.email;
                break;
              case "clientemail":
                filteredVal["Client Email"] = candidate.clientId?.email;
                break;
              case "firstName":
                filteredVal["First Name"] = candidate.candidateId?.firstName;
                break;
              case "lastName":
                filteredVal["Last Name"] = candidate.candidateId?.lastName;
                break;
              case "client":
                filteredVal["Client"] = candidate.clientId?.accountName;
                break;
              case "owner_name":
                filteredVal["Owner Name"] = candidate?.candidate_ownerName;
                break;
              case "city":
                filteredVal["City"] = candidate.candidateId?.city;
                break;
              case "state":
                filteredVal["State"] = candidate.candidateId?.state;
                break;
              case "phone":
                filteredVal["Phone"] = candidate.candidateId?.phone;
                break;
              case "DOB":
                filteredVal["Date of Birth"] =
                  candidate.candidateId?.dateofBirth;
                break;
              case "address":
                filteredVal["Address"] = candidate.candidateId?.address;
                break;
              case "aadharcardnumber":
                filteredVal["Aadhar Number"] =
                  candidate.candidateId?.AadharcardNumber;
                break;
              case "pancardnumber":
                filteredVal["PAN Number"] =
                  candidate.candidateId?.PancardNumber;
                break;
              case "designation":
                filteredVal["Designation"] = candidate.candidateId?.designation;
                break;
              case "jobtitle":
                filteredVal["Job Title"] = candidate.jobId?.jobtitle;
                break;
              case "workExperience":
                filteredVal["Comapny name"] =
                  candidate.candidateId &&
                  (candidate.candidateId.workExperience.length === 0
                    ? "N/A"
                    : candidate.candidateId.workExperience
                      .map((exp) => ({
                        ...exp,
                        startDate: exp.startDate
                          ? new Date(exp.startDate)
                          : null,
                        endDate: exp.endDate
                          ? exp.endDate.toLowerCase() === "present"
                            ? new Date()
                            : new Date(exp.endDate)
                          : exp.startDate,
                      }))
                      .sort((a, b) => (b.endDate || 0) - (a.endDate || 0))
                      .slice(0, 1)
                      .map((latestExperience, index) => {
                        return latestExperience?.companyname;
                      })[0]);
                break;
              case "educationDetails":
                filteredVal["Education"] =
                  candidate.candidateId &&
                  (candidate?.candidateId?.educationDetails.length === 0
                    ? "N/A"
                    : candidate.candidateId?.educationDetails
                      .map((edu) => ({
                        ...edu,
                        startDate: edu.startDate
                          ? new Date(
                            edu.startDate.replace(
                              /(\d{2})\/(\d{2})\/(\d{4})/,
                              "$2/$1/$3"
                            )
                          )
                          : null,
                        endDate: edu.endDate
                          ? new Date(
                            edu.endDate.replace(
                              /(\d{2})\/(\d{2})\/(\d{4})/,
                              "$2/$1/$3"
                            )
                          )
                          : null,
                      }))
                      .sort(
                        (a, b) =>
                          (b.endDate || new Date(0)) -
                          (a.endDate || new Date(0))
                      )
                      .slice(0, 1)
                      .map((latestDegree, index) => {
                        return latestDegree?.degree;
                      })[0]);
                break;
              case "experience":
                filteredVal["Experience"] = candidate.candidateId?.experiance;
                break;
              case "gender":
                filteredVal["Gender"] = candidate.candidateId?.gender;
                break;
              case "fullName":
                filteredVal["Full Name"] =
                  `${candidate.candidateId?.firstName} ${candidate.candidateId?.lastName}`;
                break;
              case "currentCandidateCTCType":
                filteredVal["Current CTC Type"] =
                  candidate.currentCandidateCTCType;
                break;
              case "currentCandidateCTC":
                filteredVal["Current CTC"] = candidate.currentCandidateCTC;
                break;
              case "expectedCandidateCTCType":
                filteredVal["Expected CTC Type"] =
                  candidate.expectedCandidateCTCType;
                break;
              case "expectedCandidateCTC":
                filteredVal["Expected CTC"] = candidate.expectedCandidateCTC;
                break;
              case "status":
                filteredVal["Status"] = candidate.status;
                break;
              case "submission_at":
                // Assuming candidate?.created_at contains the ISO 8601 formatted date string
                let isoDate = candidate?.created_at;
                if (isoDate) {
                  let date = new Date(isoDate);
                  let day = date.getUTCDate().toString().padStart(2, "0");
                  let month = (date.getUTCMonth() + 1)
                    .toString()
                    .padStart(2, "0");
                  let year = date.getUTCFullYear();
                  let formattedDate = `${day}-${month}-${year}`;
                  filteredVal["Submission date"] = formattedDate;
                }
                break;

              default:
                filteredVal[field] = candidate[field];
            }
          }
        });

        delete filteredVal.Questions;
        delete filteredVal.QnA;

        return filteredVal;
      });

    const ws = XLSX.utils.json_to_sheet(filteredSubmissions);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename + fileExtension);
    const activityOn = `Download excel from submission no number download is ${filteredSubmissions?.length}`;
    const activityDo = `Download excel`;
    const component = "submission";
    const reData = {
      name: candidate_ownerName,
      id: userId,
      action: "downloadTemplate",
      type: "candidate",
      ext: "exl"
    }
    userActivity(
      candidate_ownerName,
      userId,
      component,
      activityDo,
      activityOn,
      userRole,
      reData,
    );
    handleCloseModal();
  };

  useEffect(() => {
    getSourceData();
  }, []);

  const getSourceData = async () => {
    try {
      const response = await axios.get(`${config?.apiUrl}/api/get_source`);
      setSourceData(response.data);
    } catch (error) {
      console.error("Error fetching source data:", error);
    }
  };

  const handleEditShow = () => {
    SetEditShow(true);
  };
  const handleEditClose = () => {
    SetEditShow(false);
    setId("");
    setResumeFilePath(null);
    setParsedObjectives([]);
    editCandidateFormik.resetForm();
  };

  const handleCreateSubmission = () => {
    getCandidate(id);
    setSubmission({
      ...submission,
      candidateId: displaycandidate?._id,
      email: displaycandidate?.email,
      file: displaycandidate?.file,
      fileName: displaycandidate?.fileName,
      filePath: displaycandidate?.filePath,
      currentCandidateCTCType: displaycandidate?.currentCandidateCTCType
        ? displaycandidate?.currentCandidateCTCType
        : "Annual Salary",
      noticePeriod: displaycandidate?.noticePeriod,
      currentCandidateCTC: displaycandidate?.currentCandidateCTC
        ? displaycandidate?.currentCandidateCTC
        : "",
      expectedCandidateCTCType: displaycandidate?.expectedCandidateCTCType
        ? displaycandidate?.expectedCandidateCTCType
        : "Annual Salary",
      expectedCandidateCTC: displaycandidate?.expectedCandidateCTC
        ? displaycandidate?.expectedCandidateCTC
        : "",
      relevantExperiance: displaycandidate?.experiance
        ? displaycandidate?.experiance
        : "",
      candidate_ownerName: displaycandidate?.candidate_ownerName,
    });
    SetSearchJob(true);
  };
  const handleCreateSubmissionClose = () => {
    SetSearchJob(false);
  };

  const handleEditSubmissionShow = () => {
    SetSubmitSubmission(true);
  };

  const handleRemoveSubmissionShow = () => {
    SetRemoveSubmission(true);
  };
  const handleRemoveSubmissionClose = () => {
    SetRemoveSubmission(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
    });
  };
  const [searchBranch, setSearchBranch] = useState([]);
  const [isFilterActiveBranch, setIsFilterActiveBranch] = useState(false);

  const handleSendMailShow = () => {
    SetSendMailShow(true);
  };
  const handleSendMailClose = () => {
    SetSendMailShow(false);
    SetToemail("");
    SetCcemail("");
    SetBccemail("");
    SetSubject("");
    SetMailMessage("");
  };
  const isInvalidExperience = (value) => {
    if (value === null) return true;
    return !(typeof value === "number" || (typeof value === "string" && value.trim() !== "" && !isNaN(value)));
  };
  const handleEditSubmissionStatusShow = () => {
    SetEditSubmissionStatus(true);
  };
  const handleEditSubmissionStatusClose = () => {
    SetEditSubmissionStatus(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
    });
  };

  const handleAddEducation = () => {
    let newfield = {
      institutename: "",
      degree: "",
      startDate: "",
      endDate: "",
      percentage: "",
      category: "",
    };
    setEductionFields([...eductionFields, newfield]);
  };

  const handleAddWork = () => {
    let newfield = {
      companyname: "",
      designation: "",
      startDate: "",
      endDate: "",
      country: india.name,
      state: "",
      city: "",
      countryCode: india.isoCode,
      stateCode: "",
    };
    setWorkexperienceFields([...workExperienceFields, newfield]);
  };

  const handleAddReference = () => {
    let newfield = {
      referenceType: "",
      referenceName: "",
      companyName: "",
      designation: "",
      email: "",
      phone: "",
    };
    setReferenceFields([...referenceFields, newfield]);
  };

  const handleFormChange = (index, event) => {
    let data = [...eductionFields];
    data[index][event.target.name] = event.target.value;
    setEductionFields(data);
  };

  const handleFormWorkChange = (index, event) => {
    let data = [...workExperienceFields];
    data[index][event.target.name] = event.target.value;
    setWorkexperienceFields(data);
  };

  const handleFormWorkExpChange = (index, value, action) => {
    let data = [...workExperienceFields];
    if (action.name === "country") {
      data[index].country = value.name;
      data[index].countryCode = value.isoCode;
      data[index].state = null;
      data[index].stateCode = "";
      data[index].city = null;
    } else if (action.name === "state") {
      data[index].state = value.name;
      data[index].stateCode = value.isoCode;
      data[index].city = null;
    } else if (action.name === "city") {
      data[index].city = value.name;
    }
    setWorkexperienceFields(data);
  };

  const handleFormReferenceChange = (index, event) => {
    let data = [...referenceFields];
    data[index][event.target.name] = event.target.value;
    setReferenceFields(data);
  };

  const handleSubmitSubmissionShow = () => {
    SetSubmitSubmission(true);
  };
  const handleSubmitSubmissionClose = () => {
    SetSubmitSubmission(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
      skill: "",
    });
    setId("");
  };

  const handleChangeSubmissionPage = (event, newSubmissionPage) => {
    setSubmissionPage(newSubmissionPage);
    if (searchjob.length !== 0 || jobSearchActiveField.value !== "") {
      filterJobpostData(
        jobSearchActiveField.name !== ""
          ? jobSearchActiveField.value
          : searchjob,
        newSubmissionPage,
        rowsPerSubmissionPage,
        jobSearchActiveField.name
      );
    } else {
      filterJobpostData("", newSubmissionPage, rowsPerSubmissionPage);
    }
  };
  const handleChangeRowsPerSubmissionPage = (event) => {
    setRowsPerSubmissionPage(+event.target.value);
    setSubmissionPage(0);
    if (searchjob.length !== 0 || jobSearchActiveField.value !== "") {
      filterJobpostData(
        jobSearchActiveField.name !== ""
          ? jobSearchActiveField.value
          : searchjob,
        0,
        +event.target.value,
        jobSearchActiveField.name
      );
    } else {
      filterJobpostData("", 0, +event.target.value);
    }
  };

  const handleSubmissionPreviewShow = () => {
    SetSubmissionPreview(true);
  };
  const handleSubmissionPreviewClose = () => {
    SetSubmissionPreview(false);
    setObjectURL("");
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
    });
  };

  const saveFile = (e, type) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      document.getElementsByClassName("resumename")[0].style.display = "block";

      const reader = new FileReader();

      reader.onload = (event) => {
        const fileURL = event.target.result;

        setFile(selectedFile);
        setFileName(selectedFile.name);
        setFilePath(selectedFile.path);
        setObjectURL(fileURL);
        setResumeFilePath(fileURL);
      };

      reader.onerror = () => {
        toast.error("Error while previewing file. Try again later", {
          position: toast.POSITION.TOP_RIGHT,
        });
      };

      reader.readAsDataURL(selectedFile);
    }
  };

  const editCandidateFormik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      status: "",
      skill: "",
      experiance: "",
      designation: "",
      PancardNumber: "",
      AadharcardNumber: "",
      dateofBirth: "",
      gender: "",
      country: "India",
      password: "",
      state: "",
      city: "",
      address: "",
      pincode: "",
      source: "",
      candidateStatus: "Available",
      noticePeriod: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      file: null,
      fileName: null,
      filePath: null,
      countryCode: "",
      stateCode: "",
      updatedBy: "",
      industry: "",
      linkedIn: "",
    },
    validationSchema: editCandidate,
    onSubmit: async (item) => {
      setCandidateLoading(true);
      const originalDate = moment(item?.dateofBirth);
      const formattedDate = originalDate.format("DD/MM/YYYY");

      let data = {
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        phone: item.phone,
        password: item.password,
        status: item.status,
        skill: item.skill,
        experiance: item.experiance,
        designation: item.designation,
        PancardNumber: item.PancardNumber,
        AadharcardNumber: item.AadharcardNumber,
        dateofBirth:
          formattedDate !== "Invalid date"
            ? formattedDate
            : item.dateofBirth || "",
        gender: item.gender,
        country: item.country,
        state: item.state,
        city: item.city,
        address: item.address,
        pincode: item.pincode,
        source: item.source,
        file: item.file,
        fileName: item.fileName,
        filePath: item.filePath,
        candidateStatus: item.candidateStatus,
        educationDetails: eductionFields,
        workExperience: workExperienceFields,
        reference: referenceFields,
        noticePeriod: item?.noticePeriod,
        currentCandidateCTCType: item?.currentCandidateCTCType,
        currentCandidateCTC: item?.currentCandidateCTC,
        expectedCandidateCTCType: item?.expectedCandidateCTCType,
        expectedCandidateCTC: item?.expectedCandidateCTC,
        countryCode: item?.countryCode || selectedState?.countryCode || "IN",
        stateCode: item?.stateCode || selectedState?.isoCode,
        updatedBy: userId || '',
        industry: item?.industry || "",
        linkedIn: item?.linkedIn || "",
      };

      let configdata = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const url = `${config?.apiUrl}/api/update_candidate/${id}`;

      await axios
        .put(url, data, configdata)
        .then((response) => {
          toast.success(response.data.msg, {
            position: toast.POSITION.TOP_RIGHT,
          });
          handleEditClose();
          getCandidate(id);
          const cdid = response.data.data._id;
          const data = response.data.data;
          const activityOn = `Candidate ${data?.firstName} ${data?.lastName} has been  updated `;
          const name = data?.firstName + " " + data?.lastName
          const reData = {
            name,
            id: cdid,
            action: 'editCandidate',
            type: 'candidate',
            note: null,
          }
          userActivity(
            candidate_ownerName,
            userId,
            "candidateview",
            "Updated Candidate",
            activityOn,
            userRole,
            reData,
          );
          handleActivitySubmit(
            cdid,
            `Candidate ${data?.firstName} ${data?.lastName} has been edited`,
            new Date().getTime(),
            candidate_ownerName,
            userId
          );
          const cdName =
            localStorage.getItem("firstname") +
            " " +
            localStorage.getItem("lastname");
          const o = Object.entries(changes).map((value) => {
            return `${value[0]} : ${value[1]}`;
          });
          setCandidateLoading(false);
        })
        .catch((err) => {
          toast.error(err || "Please check details", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setCandidateLoading(false);
        });
    },
  });
  const getAllCandidateData = (data) => {
    const formattedDate = formatToDateISO(data?.dateofBirth, "YYYY-MM-DD");
    editCandidateFormik.setValues({
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      status: data.status,
      skill: data.skill,
      experiance: data.experiance,
      designation: data.designation,
      PancardNumber: data.PancardNumber || "",
      AadharcardNumber: data.AadharcardNumber || "",
      dateofBirth: formattedDate !== "Invalid date" ? formattedDate : "",
      gender: data.gender || "",
      country: "India",
      password: data.password,
      state: data.state,
      city: data.city,
      address: data.address || "",
      pincode: data.pincode || "",
      source: data.source || "",
      candidateStatus: data.candidateStatus,
      file: data.fileName,
      fileName: data.fileName,
      filePath: data.filePath,
      stateCode: selectedState?.isoCode || "",
      currentCandidateCTC: data?.currentCandidateCTC,
      currentCandidateCTCType: data?.currentCandidateCTCType,
      expectedCandidateCTC: data?.expectedCandidateCTC,
      expectedCandidateCTCType: data?.expectedCandidateCTCType,
      noticePeriod: data?.noticePeriod,
      industry: data?.industry || "",
      linkedIn: data?.linkedIn || "",
    });
    const selectedStateShppingFromData = data?.workExperience?.map((data) => {
      setSelectedWorkState({
        name: data?.state,
        isoCode: data?.stateCode,
      });
    });
    setSelectedState({
      name: data?.state,
      countryCode: data?.countryCode,
      isoCode: data?.stateCode,
    });
    setSelectedCity({
      name: data?.city,
      countryCode: data?.countryCode,
      isoCode: data?.stateCode,
    });
  };

  const SubmissionPreview = async (id) => {
    try {
      const result = await axios.get(
        `${config?.apiUrl}/api/download_Candidate_Resume/${id}?id=${userId}`
      );
      const { filePath } = result.data;
      setObjectURL(filePath);
      setResumeFilePath(filePath);
      setLoading(false);
    } catch (error) {
      setObjectURL("no-resume");
      setResumeFilePath(null);
      toast.error("Error while Preview file. Try again later", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setLoading(false);
    }
  };

  const SubmissionResumePreview = async (id, value) => {
    try {
      const result = await axios.get(
        `${config?.apiUrl}/api/download_Submission_Resume/${id}?id=${userId}`
      );
      setObjectURL(result.data);
      setLoading(false);
      const activityOn = `View resume of candidate ${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`;
      const activityDo = `View resume`;
      const component = "candidate";
      const reData = {
        name: `${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`,
        id: value?.candidateId?._id,
        action: "viewResume",
        type: "candidate",
        note: null,
      };
      userActivity(
        candidate_ownerName,
        userId,
        component,
        activityDo,
        activityOn,
        userRole,
        reData
      );
      // handleActivitySubmit &&
      //   handleActivitySubmit(
      //     value?._id,
      //     `View resume of ${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`,
      //     new Date().getTime(),
      //     candidate_ownerName,
      //     userId      
      //   );
      handleSubmissionPreviewShow(setSubmission(value), setId(value._id));
    } catch (error) {
      setObjectURL("no-resume");
      setLoading(false);
      toast.warn(error?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const handleSubmInputs = (e) => {
    let name, value;
    name = e?.target?.name;
    value = e?.target?.value;
    if (name && value) {
      setSubmission({ ...submission, [name]: value });
    } else {
      setSubmission({});
    }
  };

  const saveSubmFile = (e) => {
    setSubmission({
      ...submission,
      fileName: e.target.files[0].name,
      filePath: e.target.files[0].path,
      file: e.target.files[0],
    });
    setCandidate({
      ...candidate,
      fileName: e.target.files[0].name,
      filePath: e.target.files[0].path,
      file: e.target.files[0],
    });
  };

  const [oldStatus, setOldStatus] = useState("");
  useEffect(() => {
    submissionid && setOldStatus(submission?.status);
  }, [submissionid]);

  const handleEditSubmissionStatus = async (e) => {
    if (e) {
      e.preventDefault();
    }
    const { status } = submission;
    const url = `${config?.apiUrl}/api/appliedjob_update/${submissionid}`;
    const Credentials = { status, candidate_ownerName, userId };
    await axios
      .put(url, Credentials)
      .then(async (response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        const resonoseData = response.data.data;
        const candidateId = await resonoseData?.candidateId;
        const updateData = {
          status: resonoseData?.status,
        };
        if (
          resonoseData?.status === "Joined" ||
          resonoseData?.status === "Submitted" ||
          resonoseData?.status === "Client - Submitted" ||
          resonoseData?.status === "Internal-Submitted"
        ) {
          updateData.candidateStatus =
            resonoseData?.status === "Client - Submitted"
              ? "QA Check"
              : resonoseData?.status === "Internal-Submitted"
                ? "Submitted"
                : resonoseData?.status;
        }

        const urls = `${config?.apiUrl}/api/update_candidate/${candidateId}`;
        await axios.put(urls, updateData).then((response) => {
          const mailSend = response.data.data?.sendMail;
          // if (mailSend) {
          //   handleUpdateStatusChangeMailSendToCandidate(
          //     submission,
          //     resonoseData,
          //     oldStatus
          //   );
          // }
        });

        setOldStatus("");
        handleEditSubmissionStatusClose();
        handleFilterAllFieldStep(
          "",
          candidateSubmissionpage,
          rowsPerCandidateSubmissionPage,
          submissionModuleData
        );
      })
      .catch((err) => {
        console.log({ err });
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleDeleteSubmission = async (e) => {
    if (e) {
      e.preventDefault();
    }
    const url = `${config?.apiUrl}/api/remove_submission/${submissionid}`;
    await axios
      .delete(url)
      .then((response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        const activityOn = `Candidate ${candidate?.firstName} ${candidate?.lastName} submission has been deleted `;
        const activityDo = "Delete Submission";
        const component = "candidate";
        const name = candidate?.firstName + " " + candidate?.lastName;
        const id = candidate?.candidateId;
        const reData = {
          name: `${candidate?.firstName} ${candidate?.lastName}`,
          id: candidate._id,
          action: 'deleteSubmission',
          type: 'submission',
          note: null,
        }
        userActivity(
          candidate_ownerName,
          userId,
          component,
          activityDo,
          activityOn,
          userRole,
          reData
        );
        // getCandidateSubmission(
        //   candidateSubmissionpage,
        //   rowsPerCandidateSubmissionPage,
        //   submissionModuleData
        // );
        handleFilterAllFieldStep("", 0, 10);
        handleRemoveSubmissionClose();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleAppliedJobClientEmailSend = async (formData) => {
    const { clientemail, email, clientId, jobId } = formData;
    const jobDetails = jobposts.find((job) => job._id === jobId);
    const jobTitle = jobDetails?.jobtitle;

    if (!formData) {
      toast.error("Invalid credentials", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const response = await axios
      .post(`${config?.apiUrl}/api/Job_Applied_Client_EmailSend`, {
        email: clientemail,
        candidateEmail: email,
        clientId: clientId,
        jobTitle: jobTitle,
      })
      .then((result) => {
        toast.success(result?.data?.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const handleAppliedJobEmailSend = async (formData) => {
    const { email, jobId } = formData;

    const jobDetails = jobposts.find((job) => job._id === jobId);

    if (!formData) {
      toast.error("Invalid credentials", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const response = await axios
      .post(`${config?.apiUrl}/api/Job_Applied_EmailSend`, {
        email: email,
        jobDetails: jobDetails,
      })
      .then((result) => {
        toast.success(result?.data?.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const handleCandidateActivitySubmit = async (
    candidateId,
    _activityDes,
    _created_at,
    _submitterName
  ) => {
    const response = await axios
      .post(`${config?.apiUrl}/api/Set_Candidateactivities`, {
        candidateId: candidateId,
        jobActivity: _activityDes,
        created_at: _created_at,
        submittedBy: _submitterName,
      })
      .then((result) => {
        console.log("success activity");
        // toast.success(result.data.msg, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleActivitySubmit = async (
    _cdid,
    _activityDes,
    _created_at,
    _submittedBy,
    userId
  ) => {
    const response = await axios
      .post(`${config?.apiUrl}/api/Set_Candidateactivities`, {
        candidateId: _cdid,
        jobActivity: _activityDes,
        created_at: _created_at,
        submittedBy: _submittedBy,
        submittedById: userId
      })
      .then((result) => {
        console.log("success activity");
        // toast.success(result.data.msg, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleResumeMatching = async (e) => {
    setLoadingResumeScreening(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", submission?.file);
    formData.append("fileName", submission?.fileName);
    formData.append("filePath", submission?.filePath);
    formData.append("requiredSkill", submission?.skill);

    await axios
      .post(`${config?.apiUrl}/api/resume_screening`, formData)
      .then((result) => {
        toast.success(result.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });

        const requiredSkill = submission?.skill || submission?.candidateId?.skill;

        const pasreConclusion = result.data.data?.conclusion;
        const rdata = JSON.parse(result.data.data?.jsonResponse);
        const pAge = rdata?.age;
        setParseAge(pAge);
        const percentMatch = result.data.data?.percentageMatch;
        setParsePercentage(percentMatch);
        let parsedSkills = Array.isArray(rdata?.skills)
          ? rdata?.skills
          : rdata?.skills.split(",");
        const requiredSkillsArray = requiredSkill?.split(",");

        const matchedSkills = parsedSkills?.filter((parsedSkill) => {
          return requiredSkillsArray.some((reqSkill) => {
            // Check if the beginning of any word in parsedSkill matches the beginning of reqSkill
            const parsedWords = parsedSkill.toLowerCase().split(" ");
            const reqWords = reqSkill.toLowerCase().split(" ");

            return parsedWords.some((parsedWord) =>
              reqWords.some(
                (reqWord) =>
                  parsedWord.startsWith(reqWord) ||
                  reqWord.startsWith(parsedWord)
              )
            );
          });
        });

        const missingSkills = requiredSkillsArray?.filter(
          (reqSkill) =>
            !matchedSkills.some(
              (matchedSkill) =>
                matchedSkill.toLowerCase().startsWith(reqSkill.toLowerCase()) ||
                reqSkill.toLowerCase().startsWith(matchedSkill.toLowerCase())
            )
        );

        setMatchingSkills(matchedSkills);
        setMissingSkills(missingSkills);
        setParsedSkills(parsedSkills);
        setparseResumeConclusion(pasreConclusion);
        setLoading(false);
        setLoadingResumeScreening(false);
        document.getElementsByClassName("matched_skill")[0].style.display =
          "block";
        document.getElementsByClassName("conclusion")[0].style.display =
          "block";
        if (matchedSkills.length === 0) {
          toast.error("You don't match the required skills.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoading(false);
          setLoadingResumeScreening(false);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status == 404) {
          // Display toaster for file not found in the database
          toast.error("Resume file not found in the database.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoadingResumeScreening(false);
        } else {
          // Display a general error toaster
          toast.error(
            "Please check your resume or try again later. If the issue persists, please add your resume.",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
          setLoadingResumeScreening(false);
        }
        setLoading(false);
        setLoadingResumeScreening(false);
      });
  };

  const getCandidate = (id) => {
    axios
      .get(`${config?.apiUrl}/candidateview/${id}`)
      .then((response) => {
        const candidatedata = response.data.data;
        setCandidate(candidatedata);
        setDisplayCandidate(candidatedata);
        setEductionFields(candidatedata.educationDetails);
        setWorkexperienceFields(candidatedata.workExperience);
        setReferenceFields(candidatedata.reference);
        setEducationDetails(candidatedata.educationDetails);
        setWorkExperience(candidatedata.workExperience);
        setReferenceDetail(candidatedata.reference);
        setParsedObjectives(candidatedata?.objectives);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        setLoading(false);
      });
  };

  const getCandidateActivity = (id) => {
    axios
      .get(`${config?.apiUrl}/api/get_Candidateactivities/${id}`)
      .then((response) => {
        const activitydata = response.data.data;

        SetActivity(activitydata);
      })
      .catch((err) => {
        toast.error(
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const filterJobpostData = async (
    string = "",
    page = 0,
    limit = 10,
    fieldName
  ) => {
    const baseUrl = `${config?.apiUrl}/api/get_all_search_jobpost?page=${page + 1}&limit=${limit}&clientName=${fieldName == "clientName" ? string : searchJobClient?.value || ""}&branch=${fieldName == "branch" ? string : searchJobBranch?.value || ""}&city=${searchJobCity}&clientContactName=${searchJobContactName}&activeJob=${true}&job_ownerName=${fieldName == "job_ownerName" ? string : searchJobOwner?.value || ""}`;
    const queryObject = {
      text: searchjob,
      jobtitle: searchJobTitle,
      job_id: searchJobId,
    };
    const url = `${baseUrl}&activeJob=${true}&targetDate=${true}
      `;
    try {
      setSearchJobLoading(true);
      const filterdata = await axios.get(url, {
        params: queryObject,
        headers: {
          Authorization: `Bearer ${cookie.token}`,
          "Content-Type": "application/json",
        },
      });

      let temp = filterdata.data.data;

      const totalJobPosts = filterdata.data.totalJobPosts;
      temp.totalJobPosts = totalJobPosts;
      setJobposts(temp);
      setSearchJobLoading(false);
    } catch (error) {
      toast.error(error, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setSearchJobLoading(false);
    }

  };



  const getCandidateApplicationStatus = async () => {
    await axios
      .get(`${config.apiUrl}/api/get_All_candidate_application_status`)
      .then((response) => {
        const statusData = response.data.data;
        setApplicationStatus(statusData);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.error ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };
  const [searchSourceData, setSearchSourceData] = useState([]);

  const clearJobFilter = () => {
    setSearchJob("");
    setSearchJobTitle("");
    setJobSearchActiveField({ name: "", value: "" });
    setSearchJobContactName("");
    setSearchJobClient(null);
    setSearchJobBranch(null)
    setSearchJobOwner(null);
    setSearchJobCity("");
    filterJobpostData("", submissionpage, rowsPerSubmissionPage);
  };

  const [searchfname, setSearchFname] = useState("");
  const [searchlname, setSearchLname] = useState("");
  const [searchjobt, setSearchJobt] = useState("");
  const [searchstatus, setSearchStatus] = useState([]);
  const [searchcustomer, setSearchCustomer] = useState([]);
  const [searchOwnerName, setSearchOwnerName] = useState([]);
  const [searchcandidatectctype, setSearchCandidatectctype] = useState("");
  const [searchcandidatectc, setSearchCandidatectc] = useState("");
  const [searchcity, setSearchCity] = useState([]);
  const [searchstate, setSearchstate] = useState([]);
  const [searchSubmissionDate, setSearchSubmissionDate] = useState([]);
  const [searchSubmissionUpdateDate, setSearchSubmissionUpdateDate] = useState(
    []
  );
  const [searchExpectedCandidateCTC, setSearchExpectedCandidateCTC] =
    useState("");
  const [searchExpectedCandidateCTCType, setSearchExpectedCandidateCTCType] =
    useState("");
  const [searchNoticePeriod, setSearchNoticePeriod] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [searchAddress, setSearchAddress] = useState("");
  const [searchDOB, setSearchDOB] = useState("");
  const [searchAadharCardNumber, setSearchAadharCardNumber] = useState("");
  const [searchPanCardNumber, setSearchPanCardNumber] = useState("");
  const [searchDesignation, setSearchDesignation] = useState("");
  const [searchWorkExperience, setSearchWorkExperience] = useState("");
  const [searchEducationDetails, setSearchEducationDetails] = useState("");
  const [searchExperience, setSearchExperience] = useState("");
  const [searchGender, setSearchGender] = useState("");
  const [
    isFilterActiveSourceSearch,
    setIsFilterActiveSourceSearch,
  ] = useState(false);
  const [searchInterviewScheduleDate, setSearchInterviewScheduleDate] =
    useState([]);
  const [searchInterviewScheduleTime, setSearchInterviewScheduleTime] =
    useState("");
  const [searchInterviewScheduleLocation, setSearchInterviewScheduleLocation] =
    useState("");
  const [searchInterviewScheduleLink, setSearchInterviewScheduleLink] =
    useState("");
  const [searchJoinDate, setSearchJoinDate] = useState([]);
  const [searchSubmissionBy, setSearchSubmissionBy] = useState([]);
  const [searchEmail, setSearchEmail] = useState("");
  const [searchContactName, setSearchContactName] = useState("");
  const [activeField, setActiveField] = useState({ name: "", value: "" });
  const [searchActualCTC, setSearchActualCTC] = useState("");
  const [searchOfferCTC, setSearchOfferCTC] = useState("");
  const [searchExpectedJoinDate, setSearchExpectedJoinDate] = useState([]);
  const [searchUpdatedBy, setSearchUpdatedBy] = useState([]);
  const [searchFullName, setSearchFullName] = useState("");
  const [searchIndustry, setSearchIndustry] = useState([]);
  const [searchInterviewRescheduleDate, setSearchInterviewRescheduleDate] =
    useState([]);
  const [searchTestRescheduleDate, setSearchTestRescheduleDate] = useState([]);
  const [searchBackoutDate, setSearchBackoutDate] = useState([]);

  const [
    isFilterActiveBackoutDate,
    setIsFilterActiveBackoutDate,
  ] = useState(false);
  const [
    isFilterActiveTestRescheduleDate,
    setIsFilterActiveTestRescheduleDate,
  ] = useState(false);
  const [
    isFilterActiveInterviewRescheduleDate,
    setIsFilterActiveInterviewRescheduleDate,
  ] = useState(false);
  const [isFilterActiveIndustry, setIsFilterActiveIndustry] = useState(false);
  const [isFilterActiveFullName, setIsFilterActiveFullName] = useState(false);
  const [isFilterActiveUpdatedBy, setIsFilterActiveUpdatedBy] = useState(false);
  const [isFilterActiveExpectedJoinDate, setIsFilterActiveExpectedJoinDate] =
    useState(false);
  const [isFilterActiveUpdatedDate, setIsFilterActiveUpdatedDate] =
    useState(false);
  const [isFilterActiveOfferCTC, setIsFilterActiveOfferCTC] = useState(false);
  const [isFilterActiveActualCTC, setIsFilterActiveActualCTC] = useState(false);
  const [isFilterActiveEmail, setIsFilterActiveEmail] = useState(false);
  const [isFilterActiveSubmissionBy, setIsFilterActiveSubmissionBy] =
    useState(false);
  const [isFilterActiveJoinDate, setIsFilterActiveJoinDate] = useState(false);
  const [
    isFilterActiveInterviewScheduleLink,
    setIsFilterActiveInterviewScheduleLink,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleLocation,
    setIsFilterActiveInterviewScheduleLocation,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleTime,
    setIsFilterActiveInterviewScheduleTime,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleDate,
    setIsFilterActiveInterviewScheduleDate,
  ] = useState(false);
  const [isFilterActiveGender, setIsFilterActiveGender] = useState(false);
  const [isFilterActiveExperience, setIsFilterActiveExperience] =
    useState(false);
  const [isFilterActiveEducationDetails, setIsFilterActiveEducationDetails] =
    useState(false);
  const [isFilterActiveWorkExperience, setIsFilterActiveWorkExperience] =
    useState(false);
  const [isFilterActiveDesignation, setIsFilterActiveDesignation] =
    useState(false);
  const [isFilterActivePanCardNumber, setIsFilterActivePanCardNumber] =
    useState(false);
  const [isFilterActiveAadharCardNumber, setIsFilterActiveAadharCardNumber] =
    useState(false);
  const [isFilterActiveDOB, setIsFilterActiveDOB] = useState(false);
  const [isFilterActiveAddress, setIsFilterActiveAddress] = useState(false);
  const [isFilterActivePhone, setIsFilterActivePhone] = useState(false);
  const [isFilterActiveNoticePeriod, setIsFilterActiveNoticePeriod] =
    useState(false);
  const [isFilterActivEexpectedCtctype, setIsFilterActiveExpectedCtctype] =
    useState(false);
  const [isFilterActiveExpectedCtc, setIsFilterActiveExpectedCtc] =
    useState(false);
  const [isFilterActiveFname, setIsFilterActiveFname] = useState(false);
  const [isFilterActiveLname, setIsFilterActiveLname] = useState(false);
  const [isFilterActiveJobt, setIsFilterActiveJobt] = useState(false);
  const [isFilterActiveStatus, setIsFilterActiveStatus] = useState(false);
  const [isFilterActiveClient, setIsFilterActiveClient] = useState(false);
  const [isFilterActiveOwner, setIsFilterActiveOwner] = useState(false);
  const [isFilterActiveCtctype, setIsFilterActiveCtctype] = useState(false);
  const [isFilterActiveCtc, setIsFilterActiveCtc] = useState(false);
  const [isFilterActiveCity, setIsFilterActiveCity] = useState(false);
  const [isFilterActiveState, setIsFilterActiveState] = useState(false);
  const [isFilterActiveDate, setIsFilterActiveDate] = useState(false);
  const [isFilterActiveContactName, setIsFilterActiveContactName] =
    useState(false);

  const statusField = "all";
  const [mySubmissionValue, setMySubmissionValue] = useState("");
  const [popoverVisible, setPopoverVisible] = useState({});
  const [popoverVisibleCandidate, setPopoverVisibleCandidate] = useState({});
  // Close filter modal popover
  // const handlePopOverClose = (key, visibility) => {
  //   const newPopoverVisible = key ? { [key]: visibility } : {};
  //   setPopoverVisible(newPopoverVisible);
  // };

  const handlePopOverClose = (key, visibility) => {
    const newPopoverVisible = key
      ? { ...popoverVisible, [key]: visibility }
      : {};
    setPopoverVisible(newPopoverVisible);
  };

  const handlePopOverCandidateClose = (key, visibility) => {
    const newPopoverVisible = key
      ? { ...popoverVisibleCandidate, [key]: visibility }
      : {};
    setPopoverVisibleCandidate(newPopoverVisible);
  };

  const handleFilterAllFieldStep = async (
    string = "",
    page = 0,
    rowsPerPage = 10,
    fieldName
  ) => {
    const isClientView = true;
    let submissionByTeamSearch = [];
    if (Array.isArray(teamData) && teamData?.length) {
      submissionByTeamSearch = teamData.filter((name) => {
        return Object.values(string).some((value) =>
          value?.toString().includes(name)
        );
      });
    }
    const candidateId = id
    const url = `${config?.apiUrl}/api/get_All_search_submission?page=${page + 1}&limit=${rowsPerPage}&candidateId=${candidateId}&candidateSource=${fieldName == "candidateSource" ? string : searchSourceData}&email=${fieldName == "email" ? string : searchEmail}&status=${fieldName == "status" ? string : searchstatus}&ownerName=${fieldName == "ownerName" ? string : searchOwnerName || ""
      }&currentCandidateCTC=${fieldName == "currentCandidateCTC" ? string : searchcandidatectc}&expectedCandidateCTC=${fieldName == "expectedCandidateCTC" ? string : searchExpectedCandidateCTC}&currentCandidateCTCType=${fieldName == "currentCandidateCTCType" ? string : searchcandidatectctype}&expectedCandidateCTCType=${fieldName == "expectedCandidateCTCType" ? string : searchExpectedCandidateCTCType}&city=${fieldName == "city" ? string : searchcity || ""}&state=${fieldName == "state" ? string : searchstate || ""}&contactName=${fieldName == "contactName" ? string : searchContactName}&noticePeriod=${fieldName == "noticePeriod" ? string : searchNoticePeriod && `${searchNoticePeriod?.noticePeriod[0] || 0}-${searchNoticePeriod?.noticePeriod[1]}`}&address=${fieldName == "address" ? string : searchAddress}&DOB=${fieldName == "DOB" ? string : searchDOB}&pancardNumber=${fieldName == "pancardNumber" ? string : searchPanCardNumber}&aadharcardNumber=${fieldName == "aadharcardNumber" ? string : searchAadharCardNumber}&gender=${fieldName == "gender" ? string : searchGender}&workExperience=${fieldName == "workExperience" ? string : searchWorkExperience}&educationDetails=${fieldName == "educationDetails" ? string : searchEducationDetails}&submissionBy=${fieldName == "submissionBy"
        ? string || ""
        : searchSubmissionBy || ""
      // cookie?.role != "Admin"
      //   ? moduleData?.view == "ownrecords"
      //     ? userId?.trim()
      //     : moduleData?.view == "ownandteamrecords"
      //       ? fieldName == "submissionBy"
      //         ? teamData && Array.isArray(string)
      //           ? submissionByTeamSearch?.length == 0
      //             ? null
      //             : submissionByTeamSearch
      //           : string
      //             ? string
      //             : teamData
      //         : searchSubmissionBy.length !== 0
      //           ? searchSubmissionBy
      //           : teamData
      //             ? teamData
      //             : null
      //       : fieldName == "submissionBy"
      //         ? string || ""
      //         : searchSubmissionBy || ""
      //   : fieldName == "submissionBy"
      //     ? string || ""
      //     : searchSubmissionBy || ""
      }&statusField=${statusField !== undefined ? statusField : ""}&interviewScheduleDate=${fieldName == "interviewScheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchInterviewScheduleDate || ""}&interviewScheduleTime=${fieldName == "interviewScheduleTime" ? string : searchInterviewScheduleTime}&interviewScheduleLocation=${fieldName == "interviewScheduleLocation" ? string : searchInterviewScheduleLocation}&interviewScheduleLink=${fieldName == "interviewScheduleLink" ? string : searchInterviewScheduleLink}&joinDate=${fieldName == "joinDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchJoinDate || ""}&actualCTC=${fieldName == "actualCTC" ? string : searchActualCTC}&expectedJoinDate=${fieldName == "expectedJoinDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchExpectedJoinDate || ""}&offerCTC=${fieldName == "offerCTC" ? string : searchOfferCTC}&isClientView=${isClientView !== undefined ? isClientView : ""}&updatedBy=${fieldName == "updatedBy" ? string : searchUpdatedBy || ""}&candidateFullName=${fieldName == "candidateFullName" ? string : searchFullName}&industry=${fieldName == "industry" ? string : searchIndustry || ""}&createdAt=${fieldName == "created_at" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchSubmissionDate || ""}&updatedAt=${fieldName == "updated_at" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchSubmissionUpdateDate || ""}&interviewRescheduleDate=${fieldName == "interviewRescheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchInterviewRescheduleDate || ""}&testRescheduleDate=${fieldName == "testRescheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchTestRescheduleDate || ""}&backoutDate=${fieldName == "backoutDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchBackoutDate || ""}`;
    const queryObject = {
      searchText: fieldName == "text" ? string : searchAllfields,
      jobtitle: fieldName == "jobtitle" ? string : searchjobt,
      designation: fieldName == "designation" ? string : searchDesignation,
      phone: fieldName == "phone" ? string : searchPhone,
      submissionId: fieldName == 'submission_id' ? string : searchSubmissionId,
      branch: fieldName == "branch" ? string : searchBranch,
      experienceMin:
        fieldName === "experience"
          ? Array.isArray(string?.experience) && string.experience.length > 0 &&
            (string.experience[0] !== undefined && string.experience[0] !== null &&
              (!isNaN(string.experience[0]) || string.experience[0] === 0))
            ? string.experience[0]
            : null
          : Array.isArray(searchExperience?.experience) && searchExperience.experience.length > 0 &&
            (searchExperience.experience[0] !== undefined && searchExperience.experience[0] !== null &&
              (!isNaN(searchExperience.experience[0]) || searchExperience.experience[0] === 0))
            ? searchExperience.experience[0]
            : null,

      experienceMax:
        fieldName === "experience"
          ? Array.isArray(string?.experience) && string.experience.length > 1 &&
            (string.experience[1] !== undefined && string.experience[1] !== null &&
              (!isNaN(string.experience[1]) || string.experience[1] === 0))
            ? string.experience[1]
            : null
          : Array.isArray(searchExperience?.experience) && searchExperience.experience.length > 1 &&
            (searchExperience.experience[1] !== undefined && searchExperience.experience[1] !== null &&
              (!isNaN(searchExperience.experience[1]) || searchExperience.experience[1] === 0))
            ? searchExperience.experience[1]
            : null,
      clientName: fieldName == "clientName" ? string && string?.join(',') : searchcustomer?.join(',') || "",
    };

    try {
      setSubmissionLoading(true);
      const filterdata = await axios.get(url, {
        params: queryObject,
        headers: {
          Authorization: `Bearer ${cookie?.token}`,
          "Content-Type": "application/json",
        },
      });

      const allSubmissionData = filterdata.data.data;

      const totalSubmissionCount = filterdata.data.totalSubmissionCount;
      allSubmissionData.totalSubmissionCount = totalSubmissionCount;
      handlePopOverClose(false);
      handlePopOverCandidateClose(false);
      // setDisplaySubmissions(allSubmissionData);
      setDisplayCandidateSubmission(allSubmissionData);
      setSubmissionLoading(false);
      return allSubmissionData;
    } catch (error) {
      toast.error(error?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      handlePopOverClose(false);
      handlePopOverCandidateClose(false);
      setSubmissionLoading(false);
    }
  };
  const filterData = async (filterValue, filterField, filterDate) => {
    let candidateSubmissionpage = 0;
    setCandidateSubmissionPage(0);
    await new Promise((resolve) => {
      setTimeout(async () => {
        switch (filterField) {
          case "industry":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "industry"
            );
            setIsFilterActiveIndustry(filterValue?.length !== 0 ? true : false);
            break;
          case "firstName":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "candidateFirstName"
            );
            setIsFilterActiveFname(filterValue?.length == 0 ? false : true);
            break;
          case "branch":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "branch",
            );
            setIsFilterActiveBranch(filterValue?.length == 0 ? false : true);
            break;
          case "fullName":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "candidateFullName"
            );
            setIsFilterActiveFullName(filterValue?.length == 0 ? false : true);
            break;

          case "lastName":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "candidateLastName"
            );
            setIsFilterActiveLname(filterValue?.length == 0 ? false : true);
            break;

          case "email":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "email"
            );
            setIsFilterActiveEmail(filterValue?.length == 0 ? false : true);

            break;

          case "jobTitle":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "jobtitle"
            );
            setIsFilterActiveJobt(filterValue?.length == 0 ? false : true);
            break;

          case "status":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "status"
            );
            setIsFilterActiveStatus(filterValue?.length == 0 ? false : true);
            break;

          case "client":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "clientName"
            );
            setIsFilterActiveClient(filterValue?.length == 0 ? false : true);
            break;

          case "contactName":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "contactName"
            );
            setIsFilterActiveContactName(filterValue?.length == 0 ? false : true);
            break;

          case "owner_name":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "ownerName"
            );
            setIsFilterActiveOwner(filterValue?.length == 0 ? false : true);

            break;

          case "currentCandidateCTCType":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "currentCandidateCTCType"
            );
            setIsFilterActiveCtctype(filterValue?.length !== 0 ? true : false);
            break;

          case "currentCandidateCTC":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "currentCandidateCTC"
            );
            setIsFilterActiveCtc(filterValue?.length !== 0 ? true : false);
            break;

          case "expectedCandidateCTCType":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "expectedCandidateCTCType"
            );
            setIsFilterActiveExpectedCtctype(
              filterValue?.length !== 0 ? true : false
            );
            break;

          case "expectedCandidateCTC":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "expectedCandidateCTC"
            );
            setIsFilterActiveExpectedCtc(filterValue?.length !== 0 ? true : false);
            break;

          case "city":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "city"
            );
            setIsFilterActiveCity(filterValue?.length !== 0 ? true : false);
            break;

          case "phone":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "phone"
            );
            setIsFilterActivePhone(filterValue?.length !== 0 ? true : false);
            break;

          case "state":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "state"
            );
            setIsFilterActiveState(filterValue?.length !== 0 ? true : false);
            break;

          case "noticePeriod":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "noticePeriod"
            );
            setIsFilterActiveNoticePeriod(filterValue && filterValue.length > 0 ? filterValue[0] : null);
            break;

          case "address":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "address"
            );
            setIsFilterActiveAddress(filterValue?.length !== 0 ? true : false);
            break;

          case "DOB":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "DOB"
            );
            setIsFilterActiveDOB(filterValue?.length !== 0 ? true : false);
            break;

          case "pancardNumber":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "pancardNumber"
            );
            setIsFilterActivePanCardNumber(
              filterValue?.length !== 0 ? true : false
            );
            break;

          case "aadharcardNumber":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "aadharcardNumber"
            );
            setIsFilterActiveAadharCardNumber(
              filterValue?.length !== 0 ? true : false
            );
            break;

          case "designation":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "designation"
            );
            setIsFilterActiveDesignation(filterValue?.length !== 0 ? true : false);
            break;

          case "experience":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "experience"
            );
            setIsFilterActiveExperience(filterValue && typeof filterValue?.experience[0] == 'number' ? filterValue?.experience : null);
            break;

          case "gender":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "gender"
            );
            setIsFilterActiveGender(filterValue?.length !== 0 ? true : false);
            break;

          case "workExperience":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "workExperience"
            );
            setIsFilterActiveWorkExperience(
              filterValue?.length !== 0 ? true : false
            );
            break;

          case "educationDetails":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "educationDetails"
            );
            setIsFilterActiveEducationDetails(
              filterValue?.length !== 0 ? true : false
            );
            break;

          case "submissionBy":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "submissionBy"
            );
            setIsFilterActiveSubmissionBy(filterValue?.length !== 0 ? true : false);
            break;

          case "interviewScheduleDate":
            const { startDate, endDate } = filterValue;
            await handleFilterAllFieldStep(
              { startDate, endDate },
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "interviewScheduleDate"
            );
            setIsFilterActiveInterviewScheduleDate(
              filterValue?.startDate && filterValue?.endDate ? true : false
            );
            break;

          case "interviewScheduleTime":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "interviewScheduleTime"
            );
            setIsFilterActiveInterviewScheduleTime(
              filterValue?.length !== 0 ? true : false
            );
            break;

          case "interviewScheduleLocation":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "interviewScheduleLocation"
            );
            setIsFilterActiveInterviewScheduleLocation(
              filterValue?.length !== 0 ? true : false
            );
            break;

          case "interviewScheduleLink":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "interviewScheduleLink"
            );
            setIsFilterActiveInterviewScheduleLink(
              filterValue?.length !== 0 ? true : false
            );
            break;

          case "joinDate":
            await handleFilterAllFieldStep(
              { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
              page,
              rowsPerPage,
              "joinDate"
            );
            setIsFilterActiveJoinDate(
              filterValue?.startDate && filterValue?.endDate ? true : false
            );
            break;
          case "expectedJoinDate":
            await handleFilterAllFieldStep(
              { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
              page,
              rowsPerPage,
              "expectedJoinDate"
            );
            setIsFilterActiveExpectedJoinDate(
              filterValue?.startDate && filterValue?.endDate ? true : false
            );
            break;
          case "actualCTC":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "actualCTC"
            );
            setIsFilterActiveActualCTC(filterValue?.length !== 0 ? true : false);
            break;
          case "offerCTC":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "offerCTC"
            );
            setIsFilterActiveOfferCTC(filterValue?.length !== 0 ? true : false);
            break;

          case "created_at":
            await handleFilterAllFieldStep(
              { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "created_at"
            );
            setIsFilterActiveDate(
              filterValue?.startDate && filterValue?.endDate ? true : false
            );
            break;
          case "updated_at":
            await handleFilterAllFieldStep(
              { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "updated_at"
            );
            setIsFilterActiveUpdatedDate(
              filterValue?.startDate && filterValue?.endDate ? true : false
            );
            break;
          case "updatedBy":
            await handleFilterAllFieldStep(
              filterValue,
              candidateSubmissionpage,
              rowsPerCandidateSubmissionPage,
              "updatedBy"
            );
            setIsFilterActiveUpdatedBy(filterValue?.length !== 0 ? true : false);
            break;
          case "interviewRescheduleDate":
            await handleFilterAllFieldStep(
              { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
              page,
              rowsPerPage,
              "interviewRescheduleDate"
            );
            setIsFilterActiveInterviewRescheduleDate(
              filterValue?.startDate && filterValue?.endDate ? true : false
            );
            break;
          case "testRescheduleDate":
            await handleFilterAllFieldStep(
              { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
              page,
              rowsPerPage,
              "testRescheduleDate"
            );
            setIsFilterActiveTestRescheduleDate(
              filterValue?.startDate && filterValue?.endDate ? true : false
            );
            break;
          case "backoutDate":
            await handleFilterAllFieldStep(
              { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
              page,
              rowsPerPage,
              "backoutDate"
            );
            setIsFilterActiveBackoutDate(
              filterValue?.startDate && filterValue?.endDate ? true : false
            );
            break;
          case "source":
            await handleFilterAllFieldStep(
              filterValue,
              page,
              rowsPerPage,
              "candidateSource"
            );
            setIsFilterActiveSourceSearch(
              filterValue?.length !== 0 ? true : false
            );
            break
          case "submission_id":
            await handleFilterAllFieldStep(
              filterValue,
              page,
              rowsPerPage,
              "submission_id"
            );
            setIsFilterActiveSubmissionId(
              filterValue?.length !== 0 ? true : false
            );
            break;

          default:
            break;
        }
        resolve()
      }, 0);
    })
  };

  const getUserModules = async () => {
    try {
      const response = await axios.get(
        `${config.apiUrl}/api/getpermissions/${cookie.role}`
      );
      const modules = response.data.modules;
      const candidateModule = modules.find(
        (item) => item.module === "candidate"
      );
      if (candidateModule) {
        const permissionsData = candidateModule.permissions;
        setModuleData(permissionsData);
      }
    } catch (error) {
      console.log('error while getting modules');

    }
  }

  useEffect(() => {
    userRole != "Admin" && getUserModules();
  }, [

  ])

  const clearFilter = () => {
    setIsFilterActiveSubmissionId(false)
    setSearchSubmissionId("")
    setCandidateSubmissionPage(0);
    setSearchAllfields("");
    setSearchFname("");
    setSearchBranch([])
    setSearchLname("");
    setSearchBranch([])
    setSearchExpectedCandidateCTC('');
    setSearchExpectedCandidateCTCType('');
    setSearchJobt("");
    setSearchStatus([]);
    setSearchCustomer([]);
    setSearchOwnerName([]);
    setSearchCandidatectctype("");
    setSearchCandidatectc("");
    setSearchCity([]);
    setSearchContactName("");
    setSearchstate([]);
    setSearchCandidatectctype("");
    setSearchCandidatectc("");
    setSearchNoticePeriod("");
    setSearchPhone("");
    setSearchAddress("");
    setSearchDOB("");
    setSearchAadharCardNumber("");
    setSearchPanCardNumber("");
    setSearchDesignation("");
    setSearchWorkExperience("");
    setSearchEducationDetails("");
    setSearchExperience("");
    setSearchGender("");
    setSearchInterviewScheduleDate([]);
    setSearchSubmissionDate([]);
    setSearchSubmissionUpdateDate([]);
    setSearchInterviewScheduleLink("");
    setSearchInterviewScheduleLocation("");
    setSearchInterviewScheduleTime("");
    setSearchJoinDate([]);
    setSearchSubmissionBy([]);
    setSearchEmail("");
    setActiveField({ name: "", value: "" });
    setSearchActualCTC("");
    setSearchOfferCTC("");
    setSearchExpectedJoinDate([]);
    setSearchUpdatedBy([]);
    setMySubmissionValue("");
    setSearchFullName("");
    setSearchIndustry([]);
    setSearchInterviewRescheduleDate([]);
    setSearchTestRescheduleDate([]);
    setSearchBackoutDate([])

    setIsFilterActiveBackoutDate(false)
    setIsFilterActiveTestRescheduleDate(false);
    setIsFilterActiveInterviewRescheduleDate(false);
    setIsFilterActiveIndustry(false);
    setIsFilterActiveFullName(false);
    setIsFilterActiveUpdatedBy(false);
    setIsFilterActiveUpdatedDate(false);
    setIsFilterActiveExpectedJoinDate(false);
    setIsFilterActiveOfferCTC(false);
    setIsFilterActiveActualCTC(false);
    setIsFilterActiveEmail(false);
    setIsFilterActiveSubmissionBy(false);
    setIsFilterActiveJoinDate(false);
    setIsFilterActiveInterviewScheduleTime(false);
    setIsFilterActiveInterviewScheduleLocation(false);
    setIsFilterActiveInterviewScheduleLink(false);
    setIsFilterActiveInterviewScheduleDate(false);
    setIsFilterActiveGender(false);
    setIsFilterActiveExperience(false);
    setIsFilterActiveEducationDetails(false);
    setIsFilterActiveWorkExperience(false);
    setIsFilterActiveContactName(false);
    setIsFilterActiveDesignation(false);
    setIsFilterActivePanCardNumber(false);
    setIsFilterActiveAadharCardNumber(false);
    setIsFilterActiveDOB(false);
    setIsFilterActiveAddress(false);
    setIsFilterActivePhone(false);
    setIsFilterActiveNoticePeriod(false);
    setIsFilterActiveExpectedCtc(false);
    setIsFilterActiveExpectedCtctype(false);
    setIsFilterActiveFname(false);
    setIsFilterActiveLname(false);
    setIsFilterActiveJobt(false);
    setIsFilterActiveStatus(false);
    setIsFilterActiveClient(false);
    setIsFilterActiveOwner(false);
    setIsFilterActiveCtctype(false);
    setIsFilterActiveCtc(false);
    setIsFilterActiveCity(false);
    setIsFilterActiveState(false);
    setIsFilterActiveDate(false);
    // getAllSubmissiondata(page, rowsPerPage, moduleData);
    handleFilterAllFieldStep("", 0, rowsPerPage, moduleData);
    setIsFilterActiveSourceSearch(false)
    setSearchSourceData([])
  };

  const fetchModuleData = async () => {
    try {
      const response = userRole != 'Admin' ? await axios.get(
        `${config.apiUrl}/api/getpermissions/${cookie.role}`
      ) : {};
      const modules = response.data.modules;
      const candidateModule = modules?.find(
        (item) => item.module === "candidate"
      );
      const submissionModule = modules.find(
        (item) => item.module === "submission"
      );
      if (submissionModule) {
        const permissionsData = submissionModule.permissions;
        setSubmissionModuleData(permissionsData);
      }
      submissionModule &&
        (await handleFilterAllFieldStep(
          "",
          candidateSubmissionpage,
          rowsPerCandidateSubmissionPage,
          submissionModule?.permissions
        ));
      const interviewscheduleModule = modules.find(
        (item) => item.module === "interviewschedule"
      );
      if (interviewscheduleModule) {
        const permissionsData = interviewscheduleModule.permissions;
        setInterviewscheduleModuleData(permissionsData);
      }
      if (candidateModule) {
        const permissionsData = candidateModule.permissions;
        setModuleData(permissionsData);
      } else {
        console.log("Candidate module not found");
      }
    } catch (error) {
      error &&
        handleFilterAllFieldStep(
          "",
          candidateSubmissionpage,
          rowsPerCandidateSubmissionPage
        );
      console.error("Error while fetching module data:", error);
    }
  };

  useEffect(() => {
    cookie?.role && fetchModuleData();
  }, [cookie.role]);

  useEffect(() => {
    const activityOn = `View ${candidate?.firstName} ${candidate?.lastName} `;
    const activityDo = "View Candidate";
    const component = "candidate";
    const name = candidate?.firstName + " " + candidate?.lastName
    const id = candidate._id
    const reData = {
      name,
      id,
      action: 'viewCandidate',
      type: 'candidate',
      note: null,
    }
    candidate.firstName &&
      userActivity(
        candidate_ownerName,
        userId,
        component,
        activityDo,
        activityOn,
        userRole,
        reData
      );
  }, [candidate.firstName]);

  const getCandidateStatus = () => {
    axios
      .get(`${config?.apiUrl}/api/get_All_candidate_status`)
      .then((response) => {
        const statusdata = response.data.data;
        setCandidateStatus(statusdata);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.error ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };
  const [industries, setIndustries] = useState([]);
  const getIndustryData = async () => {
    try {
      const response = await axios.get(
        `${config?.apiUrl}/api/get_all_industries`
      );
      setIndustries(response?.data);
    } catch (error) {
      console.error("Error fetching industry data:", error);
    }
  };

  useEffect(() => {
    if (cookie?.token?.length) {
      getCandidate(id);
      getCandidateActivity(id);
      getIndustryData();
      // getCandidateSubmission(
      //   candidateSubmissionpage,
      //   rowsPerCandidateSubmissionPage,
      //   submissionModuleData
      // );
      filterJobpostData("", submissionpage, rowsPerSubmissionPage);
      getCandidateApplicationStatus();
      getCandidateStatus();
    } else {
      history.replace("/");
    }
  }, [cookie]);
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <Box>
      <ToastContainer />
      <Box
        className={isSidebarOpen ? "content_details" : "content_details_nav"}
      >
        <div
          style={{
            width: "auto",
            margin: "5rem 0rem 1rem 0rem",
          }}
        >
          <Flex
            position="relative"
            direction="column"
            align={{ sm: "center" }}
            maxW="auto"
            height="auto"
            mx="auto"
            bg={useColorModeValue("white", "gray.700")}
            shadow={{ sm: "base" }}
            rounded={{ sm: "lg" }}
            padding="7px 20px 7px 20px"
          >
            <Avatar
              mt="-10"
              borderWidth="6px"
              borderColor={useColorModeValue("white", "gray.700")}
              size="xl"
              name={displaycandidate?.firstName}
              className="bg_color"
              color="white"
            />


            <div className="box_details">
              <Box textAlign={{ sm: "center" }} pt="2">
                <Heading
                  size="lg"
                  fontWeight="extrabold"
                  letterSpacing="tight"
                  className="title_color"
                >
                  {!displaycandidate?.firstName
                    ? "N/A"
                    : displaycandidate?.firstName}{" "}
                  {!displaycandidate?.lastName
                    ? "N/A"
                    : displaycandidate?.lastName}
                </Heading>
                <Text style={{ fontWeight: "bold" }}>
                  {!displaycandidate?.uniqueCandidateId
                    ? "N/A"
                    : `TKC-${displaycandidate?.uniqueCandidateId}`}
                </Text>
                <Text color={useColorModeValue("gray.600", "gray.400")}>
                  {!displaycandidate?.designation
                    ? "N/A"
                    : displaycandidate?.designation}
                </Text>
              </Box>
              <hr className="horizontal_line" />
              <div>
                <Text color={useColorModeValue("gray.600", "gray.400")}>
                  City :{" "}
                  {!displaycandidate?.city ? "N/A" : displaycandidate?.city}
                </Text>
                <Text color={useColorModeValue("gray.600", "gray.400")}>
                  Experience :{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {!displaycandidate?.experiance
                      ? "N/A"
                      : displaycandidate?.experiance}
                  </span>
                </Text>
                <Text color={useColorModeValue("gray.600", "gray.400")}>
                  Created On :{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {!displaycandidate?.created_at
                      ? "N/A"
                      : typeof displaycandidate?.created_at === "string"
                        ? displaycandidate?.created_at
                        : new Date(
                          displaycandidate?.created_at
                        ).toLocaleDateString("en-GB")}
                  </span>
                </Text>
              </div>
              <hr className="horizontal_line" />
              <div>
                <Button
                  style={{
                    color: "white",
                    border: "1px solid #d7d7d7",
                    fontWeight: "500",
                    letterSpacing: "1px",
                    fontSize: "14px",
                  }}
                  className="bg_color"
                  onClick={() => {
                    handleCreateSubmission();
                    setSubmission({
                      ...submission,
                      candidateId: displaycandidate?._id,
                      email: displaycandidate?.email,
                      file: displaycandidate?.file,
                      fileName: displaycandidate?.fileName,
                      filePath: displaycandidate?.filePath,
                      currentCandidateCTCType:
                        displaycandidate?.currentCandidateCTCType
                          ? displaycandidate?.currentCandidateCTCType
                          : "Annual Salary",
                      currentCandidateCTC: displaycandidate?.currentCandidateCTC
                        ? displaycandidate?.currentCandidateCTC
                        : "",
                      expectedCandidateCTCType:
                        displaycandidate?.expectedCandidateCTCType
                          ? displaycandidate?.expectedCandidateCTCType
                          : "Annual Salary",
                      expectedCandidateCTC:
                        displaycandidate?.expectedCandidateCTC
                          ? displaycandidate?.expectedCandidateCTC
                          : "",
                      relevantExperiance: displaycandidate?.experiance
                        ? displaycandidate?.experiance
                        : "",
                      candidate_ownerName: displaycandidate?.candidate_ownerName
                        ? displaycandidate?.candidate_ownerName
                        : "",
                      noticePeriod: displaycandidate?.noticePeriod
                        ? displaycandidate?.noticePeriod
                        : "",
                    });
                  }}
                >
                  Submit Job
                </Button>
                <Button
                  className="bg_color"
                  style={{
                    color: "white",
                    border: "1px solid #d7d7d7",
                    fontWeight: "500",
                    letterSpacing: "1px",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    handleCandidateNoteShow();
                    setNote({
                      ...note,
                      candidateId: displaycandidate?._id,
                    });
                    getCandidatNotes(displaycandidate?._id);
                  }}
                >
                  Notes
                </Button>
              </div>
            </div>
          </Flex>
        </div>
        <Tabs
          style={{
            width: "100%",
          }}
          variant="enclosed"
          defaultIndex={iParam ? Number(iParam) : 1}
        >
          <TabList
            style={{ flexWrap: "wrap", padding: "1rem", display: "flex" }}
          >
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Overview
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Info
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Submission ({displaycandidateSubmission?.totalSubmissionCount})
            </Tab>
            {/* <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Interview ({interviewedCandidates?.length})
            </Tab> */}
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Activities
            </Tab>

            <span style={{ marginLeft: "auto", fontSize: "20px" }}>
              {" "}
              <span style={{ paddingLeft: "10px", position: "relative" }}>
                <Tooltip hasArrow label="Notes" bg="gray.300" color="black">
                  <Button
                    className="candi_btns"
                    style={{}}
                    onClick={() => {
                      // handleCandidateViewNoteShow();
                      setCandidateNote({
                        ...candidateNote,
                        candidateId: displaycandidate?._id,
                      });
                      setNote({
                        ...note,
                        candidateId: displaycandidate._id,
                        clientId: displaycandidate?.clientId?._id,
                      });
                      getCandidatNotes(displaycandidate?._id);
                    }}
                  >
                    Notes (
                    {displaycandidate?.noteCount
                      ? displaycandidate?.noteCount
                      : 0}
                    )
                  </Button>
                </Tooltip>
              </span>
            </span>
          </TabList>

          <TabPanels>
            <TabPanel>
              <Box>
                <Row>
                  <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                    <div
                      style={{
                        backgroundColor: "#e3ebf8",
                        padding: "30px",
                        width: "auto",
                        height: "100%",
                        borderRadius: "10px",
                        boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                      }}
                    >
                      <div class="container">
                        <div
                          className="row"
                          style={{ gap: "23px", height: "auto" }}
                        >
                          <div
                            className="col-sm"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "end",
                              paddingBottom: "16px",
                              backgroundColor: "white",
                              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                              borderRadius: "8px",
                            }}
                          >
                            <Text fontSize="lg" color="muted">
                              Pipelined
                            </Text>
                            <Link
                              to={`/admin/total_Pipelined?id=${id}&type=candidatesub`}
                              target="_blank"
                            >
                              <Heading
                                style={{
                                  display: "flex",
                                  fontSize: "23px",
                                  padding: "40px",
                                  cursor: "pointer",
                                }}
                              >
                                {pipelinedCandidates?.length}
                              </Heading>
                            </Link>
                          </div>
                          <div
                            className="col-sm"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "end",
                              paddingBottom: "16px",
                              backgroundColor: "white",
                              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                              borderRadius: "8px",
                            }}
                          >
                            <Text fontSize="lg" color="muted">
                              Submitted
                            </Text>
                            <Link
                              to={`/admin/total_Submitted?id=${id}&type=candidatesub`}
                            >
                              <Heading
                                style={{
                                  display: "flex",
                                  fontSize: "23px",
                                  padding: "40px",
                                  cursor: "pointer",
                                }}
                              >
                                {candidateSubmission?.length}
                              </Heading>
                            </Link>
                          </div>
                          <div
                            className="col-sm"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "end",
                              paddingBottom: "16px",
                              backgroundColor: "white",
                              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                              borderRadius: "8px",
                            }}
                          >
                            <Text fontSize="lg" color="muted">
                              Interviewed
                            </Text>
                            <Link
                              to={`/admin/total_Interviewed?id=${id}&type=candidatesub`}
                            >
                              <Heading
                                style={{
                                  display: "flex",
                                  fontSize: "23px",
                                  padding: "40px",
                                  cursor: "pointer",
                                }}
                              >
                                {interviewedCandidates?.length}
                              </Heading>
                            </Link>
                          </div>
                          <div
                            className="col-sm"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "end",
                              paddingBottom: "16px",
                              backgroundColor: "white",
                              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                              borderRadius: "8px",
                            }}
                          >
                            <Text fontSize="lg" color="muted">
                              Selected
                            </Text>
                            <Link
                              to={`/admin/total_SelectedCandidates?id=${id}&type=candidatesub`}
                            >
                              <Heading
                                style={{
                                  display: "flex",
                                  fontSize: "23px",
                                  padding: "40px",
                                  cursor: "pointer",
                                }}
                              >
                                {selectedCandidates?.length}
                              </Heading>
                            </Link>
                          </div>
                          <div
                            className="col-sm"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "end",
                              paddingBottom: "16px",
                              backgroundColor: "white",
                              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                              borderRadius: "8px",
                            }}
                          >
                            <Text fontSize="lg" color="muted">
                              Accepted
                            </Text>
                            <Link
                              to={`/admin/total_JoinedCandidates?id=${id}&type=candidatesub`}
                            >
                              <Heading
                                style={{
                                  display: "flex",
                                  fontSize: "23px",
                                  padding: "40px",
                                  cursor: "pointer",
                                }}
                              >
                                {acceptedCandidates?.length}
                              </Heading>
                            </Link>
                          </div>
                          <div
                            className="col-sm"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "end",
                              paddingBottom: "16px",
                              backgroundColor: "white",
                              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                              borderRadius: "8px",
                            }}
                          >
                            <Text fontSize="lg" color="muted">
                              Onboarded
                            </Text>
                            <Link
                              to={`/admin/total_OnboardedCandidates?id=${id}&type=candidatesub`}
                            >
                              <Heading
                                style={{
                                  display: "flex",
                                  fontSize: "23px",
                                  padding: "40px",
                                  cursor: "pointer",
                                }}
                              >
                                {onboardedCandidates?.length}
                              </Heading>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                    <div
                      style={{
                        backgroundColor: "#e3ebf8",
                        padding: "30px",
                        width: "auto",
                        height: "100%",
                        borderRadius: "10px",
                        boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                      }}
                    >
                      <Heading
                        style={{
                          fontSize: "20px",
                          marginBottom: "15px",
                        }}
                        className="title_color"
                      >
                        To-Do
                      </Heading>
                      <UnorderedList>
                        <ListItem>0 Tasks pending</ListItem>
                        <ListItem>
                          {interviewedCandidates?.length} Interviews upcoming
                        </ListItem>
                        <ListItem>
                          {interviewfeedbackCandidates?.length} Interviews
                          awaiting feedback
                        </ListItem>
                        <ListItem>
                          {pipelinedCandidates?.length} Submissions pending
                        </ListItem>
                      </UnorderedList>
                    </div>
                  </Col>
                </Row>
              </Box>
            </TabPanel>
            <TabPanel>
              <Card style={{ width: "100%", marginBottom: "2rem" }}>
                <Card.Header style={{ textAlign: "left", fontWeight: "bold" }}>
                  Personal Details
                </Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item style={{ textAlign: "left" }}>
                    <Container style={{ minWidth: "100%" }}>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            FirstName
                          </Text>
                          <span>
                            {!displaycandidate?.firstName
                              ? "N/A"
                              : displaycandidate?.firstName}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            LastName
                          </Text>
                          <span>
                            {!displaycandidate?.lastName
                              ? "N/A"
                              : displaycandidate?.lastName}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Email
                          </Text>
                          <span>
                            {!displaycandidate?.email
                              ? "N/A"
                              : displaycandidate?.email}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Mobile
                          </Text>
                          <span>
                            {!displaycandidate?.phone
                              ? "N/A"
                              : displaycandidate?.phone}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            LinkedIn
                          </Text>
                          <span>
                            {!displaycandidate?.linkedIn
                              ? "N/A"
                              : <a href={displaycandidate?.linkedIn} target="_blank" rel="noopener noreferrer" style={{ color: "#0077b5" }}>{displaycandidate?.linkedIn}</a>}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Years of Experience
                          </Text>
                          <span>
                            {isInvalidExperience(displaycandidate?.experiance)
                              ? "N/A"
                              : displaycandidate?.experiance}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Candidate Designation
                          </Text>
                          <span>
                            {!displaycandidate?.designation
                              ? "N/A"
                              : displaycandidate?.designation}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Candidate Status
                          </Text>
                          <span>
                            {!displaycandidate?.candidateStatus
                              ? "N/A"
                              : displaycandidate?.candidateStatus}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Date of Birth
                          </Text>
                          <span>
                            {!displaycandidate?.dateofBirth
                              ? "N/A"
                              : displaycandidate?.dateofBirth}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Skills
                          </Text>
                          <span>
                            {!displaycandidate?.skill
                              ? "N/A"
                              : displaycandidate?.skill}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Country
                          </Text>
                          <span>
                            {!displaycandidate?.country
                              ? "N/A"
                              : displaycandidate?.country}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            State
                          </Text>
                          <span>
                            {!displaycandidate?.state
                              ? "N/A"
                              : displaycandidate?.state}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            City
                          </Text>
                          <span>
                            {!displaycandidate?.city
                              ? "N/A"
                              : displaycandidate?.city}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            PAN Card Number
                          </Text>
                          <span>
                            {!displaycandidate?.PancardNumber
                              ? "N/A"
                              : displaycandidate?.PancardNumber}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Aadhar Card Number
                          </Text>
                          <span>
                            {!displaycandidate?.AadharcardNumber
                              ? "N/A"
                              : displaycandidate?.AadharcardNumber}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Gender
                          </Text>
                          <span>
                            {!displaycandidate?.gender
                              ? "N/A"
                              : displaycandidate?.gender}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Address
                          </Text>
                          <span>
                            {!displaycandidate?.address
                              ? "N/A"
                              : displaycandidate?.address}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Pincode
                          </Text>
                          <span>
                            {!displaycandidate?.pincode
                              ? "N/A"
                              : displaycandidate?.pincode}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Source
                          </Text>
                          <span>
                            {!displaycandidate?.source
                              ? "N/A"
                              : displaycandidate?.source}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Candidate Application Status
                          </Text>
                          <span>
                            {!displaycandidate?.status
                              ? "N/A"
                              : displaycandidate?.status}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Current CTC
                          </Text>
                          <span>
                            {!displaycandidate?.currentCandidateCTC
                              ? "N/A"
                              : displaycandidate?.currentCandidateCTC}
                            {!displaycandidate?.currentCandidateCTCType
                              ? " / N/A"
                              : " / " +
                              displaycandidate?.currentCandidateCTCType}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Expected CTC
                          </Text>
                          <span>
                            {!displaycandidate?.expectedCandidateCTC
                              ? "N/A"
                              : displaycandidate?.expectedCandidateCTC}
                            {!displaycandidate?.expectedCandidateCTCType
                              ? " / N/A"
                              : " / " +
                              displaycandidate?.expectedCandidateCTCType}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Notice Period
                          </Text>
                          <span>
                            {isNaN(displaycandidate?.noticePeriod)
                              ? "N/A"
                              : displaycandidate?.noticePeriod}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Candidate owner name
                          </Text>
                          <span>
                            {!displaycandidate?.candidate_ownerName?.firstName
                              ? "N/A"
                              : displaycandidate?.candidate_ownerName?.lastName}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Updated By
                          </Text>
                          <span>
                            {!displaycandidate?.updatedBy?.firstName
                              ? "N/A"
                              : displaycandidate?.updatedBy?.lastName}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Industry
                          </Text>
                          <span>
                            {!displaycandidate?.industry
                              ? "N/A"
                              : displaycandidate?.industry}
                          </span>
                        </Col>
                      </Row>
                    </Container>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
              {educationDetails.map((education) => (
                <Card
                  style={{ width: "100%", marginBottom: "2rem" }}
                  key={education.institutename}
                >
                  <Card.Header
                    style={{ textAlign: "left", fontWeight: "bold" }}
                  >
                    Education Details
                  </Card.Header>
                  <ListGroup variant="flush">
                    <ListGroup.Item>
                      <Container style={{ minWidth: "100%" }}>
                        <Row>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Institute Name
                            </Text>
                            <span>
                              {!education?.institutename
                                ? "N/A"
                                : education?.institutename}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Degree
                            </Text>
                            <span>
                              {!education?.degree ? "N/A" : education?.degree}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Start Date
                            </Text>
                            <span>
                              {!education?.startDate
                                ? "N/A"
                                : education?.startDate}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              End Date
                            </Text>
                            <span>
                              {!education?.endDate ? "N/A" : education?.endDate}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Percentage
                            </Text>
                            <span>
                              {!education?.percentage
                                ? "N/A"
                                : education?.percentage}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Category
                            </Text>
                            <span>
                              {!education?.category
                                ? "N/A"
                                : education?.category}
                            </span>
                          </Col>
                        </Row>
                      </Container>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              ))}
              {workExperience.map((work) => (
                <Card
                  style={{ width: "100%", marginBottom: "2rem" }}
                  key={work.companyname}
                >
                  <Card.Header
                    style={{ textAlign: "left", fontWeight: "bold" }}
                  >
                    Work Experience Details
                  </Card.Header>
                  <ListGroup variant="flush">
                    <ListGroup.Item style={{ textAlign: "left" }}>
                      <Container style={{ minWidth: "100%" }}>
                        <Row>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              companyname
                            </Text>
                            <span>
                              {!work?.companyname ? "N/A" : work?.companyname}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Designation
                            </Text>
                            <span>
                              {!work?.designation ? "N/A" : work?.designation}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Start Date
                            </Text>
                            <span>
                              {!work?.startDate ? "N/A" : work?.startDate}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              End Date
                            </Text>
                            <span>
                              {!work?.endDate ? "N/A" : work?.endDate}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Country
                            </Text>
                            <span>
                              {!work?.country ? "N/A" : work?.country}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              State
                            </Text>
                            <span>{!work?.state ? "N/A" : work?.state}</span>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              City
                            </Text>
                            <span>{!work?.city ? "N/A" : work?.city}</span>
                          </Col>
                        </Row>
                      </Container>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              ))}
              {referenceDetail.map((reference) => (
                <Card
                  style={{ width: "100%", marginBottom: "2rem" }}
                  key={reference.referenceType}
                >
                  <Card.Header
                    style={{ textAlign: "left", fontWeight: "bold" }}
                  >
                    Reference Details
                  </Card.Header>
                  <ListGroup variant="flush">
                    <ListGroup.Item style={{ textAlign: "left" }}>
                      <Container style={{ minWidth: "100%" }}>
                        <Row>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Reference Type
                            </Text>
                            <span>
                              {!reference?.referenceType
                                ? "N/A"
                                : reference?.referenceType}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Reference Name
                            </Text>
                            <span>
                              {!reference?.referenceName
                                ? "N/A"
                                : reference?.referenceName}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Company Name
                            </Text>
                            <span>
                              {!reference?.companyName
                                ? "N/A"
                                : reference?.companyName}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Designation
                            </Text>
                            <span>
                              {!reference?.designation
                                ? "N/A"
                                : reference?.designation}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Email
                            </Text>
                            <span>
                              {!reference?.email ? "N/A" : reference?.email}
                            </span>
                          </Col>
                          <Col
                            lg={4}
                            md={6}
                            sm={4}
                            style={{ marginBottom: "1rem" }}
                          >
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                              style={{ fontWeight: "bold" }}
                            >
                              Phone
                            </Text>
                            <span>
                              {!reference?.phone ? "N/A" : reference?.phone}
                            </span>
                          </Col>
                        </Row>
                      </Container>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              ))}
              <Box className="btns_box">
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "1rem",
                  }}
                >
                  <button
                    className="candi_btns"
                    onClick={() => {
                      SubmissionPreview(candidate?._id, candidate?.filePath);
                      handleSubmissionPreviewShow(
                        setSubmission(candidate),
                        setId(candidate._id)
                      );
                      const activityOn = `View resume of candidate`;
                      const activityDo = `View resume`;
                      const component = "candidate";
                      const name =
                        candidate?.firstName + " " + candidate?.lastName;
                      const id = candidate._id;
                      const reData = {
                        name,
                        id,
                        action: "viewResume",
                        type: "candidate",
                        note: null,
                      };
                      userActivity(
                        candidate_ownerName,
                        userId,
                        component,
                        activityDo,
                        activityOn,
                        userRole,
                        reData
                      );
                      handleActivitySubmit(
                        candidate?._id,
                        `View resume of ${candidate?.firstName} ${candidate?.lastName}`,
                        new Date().getTime(),
                        candidate_ownerName,
                        userId,
                        name
                      );
                    }}
                  >
                    Resume Preview
                  </button>
                  <Button
                    disabled={
                      (moduleData && moduleData.edit == "none") ||
                      (moduleData?.edit == "ownrecords" &&
                        candidate?.candidate_ownerName?._id !== userId)
                    }
                    className="candi_btns"
                    onClick={() => {
                      handleEditShow(setId(candidate._id));
                      getAllCandidateData(candidate);
                      SubmissionPreview(candidate._id, candidate.filePath);
                    }}
                  >
                    Edit
                  </Button>
                </Box>
              </Box>
            </TabPanel>
            <TabPanel>
              <CommonSubmissionFile
                isFilterActiveSubmissionId={isFilterActiveSubmissionId}
                searchSubmissionId={searchSubmissionId}
                setSearchSubmissionId={setSearchSubmissionId}
                setIsFilterActiveUpdatedBy={setIsFilterActiveUpdatedBy}
                setIsFilterActiveExperience={setIsFilterActiveExperience}
                setIsFilterActiveNoticePeriod={setIsFilterActiveNoticePeriod}
                setIsFilterActiveSourceSearch={setIsFilterActiveSourceSearch}
                setIsFilterActiveIndustry={setIsFilterActiveIndustry}
                setIsFilterActiveState={setIsFilterActiveState}
                setIsFilterActiveCity={setIsFilterActiveCity}
                setIsFilterActiveClient={setIsFilterActiveClient}
                setIsFilterActiveOwner={setIsFilterActiveOwner}
                setIsFilterActiveStatus={setIsFilterActiveStatus}
                setDisplaySubmissions={setDisplayCandidateSubmission}
                displaysubmissions={displaycandidateSubmission}
                Searchicon={Searchicon}
                setActivityStatus={setActivityStatus}
                searchAllfields={searchAllfields}
                setSearchAllfields={setSearchAllfields}
                moduleData={submissionModuleData}
                handleCreateSubmission={handleCreateSubmission}
                setId={setId}
                handleSubmHeaderOrdersshow={handleSubmHeaderOrdersshow}
                SetIschecked={SetIschecked}
                handleSendMailShow={handleSendMailShow}
                handleOpenModal={handleOpenModal}
                checked={checked}
                handleEditShow={handleEditSubmissionShow}
                setSubmission={setSubmission}
                handleDeleteSubmissionShow={handleRemoveSubmissionShow}
                handleCandidateNoteShow={handleCandidateNoteShow}
                getCandidatNotes={getCandidatNotes}
                SubmissionPreview={SubmissionResumePreview}
                handleSubmissionPreviewShow={handleSubmissionPreviewShow}
                handleEditSubmissionStatusShow={handleEditSubmissionStatusShow}
                // setChangeStatus={setChangeStatus}
                setOldJobId={setOldJobId}
                page={candidateSubmissionpage}
                rowsPerPage={rowsPerCandidateSubmissionPage}
                applicationStatus={applicationStatus}
                loading={submissionLoading}
                setLoading={setSubmissionLoading}
                // changeStatus={changeStatus}
                setNote={setNote}
                note={note}
                submheaderOrders={submheaderOrders}
                submissions={candidateSubmission}
                setPage={setCandidateSubmissionPage}
                setRowsPerPage={setRowsPerCandidateSubmissionPage}
                componentName={"all"}
                setSubmissionId={setSubmissionId}
                isClientView={true}
                candidateFname={candidate?.firstName}
                candidateLname={candidate?.lastName}
                teamData={teamData}
                setActiveField={setActiveField}
                activeField={activeField}
                clearFilter={clearFilter}
                searchfname={searchfname}
                setSearchFname={setSearchFname}
                searchlname={searchlname}
                setSearchLname={setSearchLname}
                searchjobt={searchjobt}
                setSearchJobt={setSearchJobt}
                searchstatus={searchstatus}
                setSearchStatus={setSearchStatus}
                searchcustomer={searchcustomer}
                setSearchCustomer={setSearchCustomer}
                searchOwnerName={searchOwnerName}
                setSearchOwnerName={setSearchOwnerName}
                searchcandidatectctype={searchcandidatectctype}
                setSearchCandidatectctype={setSearchCandidatectctype}
                searchcandidatectc={searchcandidatectc}
                setSearchCandidatectc={setSearchCandidatectc}
                searchcity={searchcity}
                setSearchCity={setSearchCity}
                searchstate={searchstate}
                setSearchstate={setSearchstate}
                searchSubmissionDate={searchSubmissionDate}
                setSearchSubmissionDate={setSearchSubmissionDate}
                searchSubmissionUpdateDate={searchSubmissionUpdateDate}
                setSearchSubmissionUpdateDate={setSearchSubmissionUpdateDate}
                searchExpectedCandidateCTC={searchExpectedCandidateCTC}
                setSearchExpectedCandidateCTC={setSearchExpectedCandidateCTC}
                searchExpectedCandidateCTCType={searchExpectedCandidateCTCType}
                setSearchExpectedCandidateCTCType={
                  setSearchExpectedCandidateCTCType
                }
                searchNoticePeriod={searchNoticePeriod}
                setSearchNoticePeriod={setSearchNoticePeriod}
                searchPhone={searchPhone}
                setSearchPhone={setSearchPhone}
                searchAddress={searchAddress}
                setSearchAddress={setSearchAddress}
                searchDOB={searchDOB}
                setSearchDOB={setSearchDOB}
                searchAadharCardNumber={searchAadharCardNumber}
                setSearchAadharCardNumber={setSearchAadharCardNumber}
                searchPanCardNumber={searchPanCardNumber}
                setSearchPanCardNumber={setSearchPanCardNumber}
                searchDesignation={searchDesignation}
                setSearchDesignation={setSearchDesignation}
                searchWorkExperience={searchWorkExperience}
                setSearchWorkExperience={setSearchWorkExperience}
                searchEducationDetails={searchEducationDetails}
                setSearchEducationDetails={setSearchEducationDetails}
                searchExperience={searchExperience}
                setSearchExperience={setSearchExperience}
                searchGender={searchGender}
                setSearchGender={setSearchGender}
                searchInterviewScheduleDate={searchInterviewScheduleDate}
                setSearchInterviewScheduleDate={setSearchInterviewScheduleDate}
                searchInterviewScheduleTime={searchInterviewScheduleTime}
                setSearchInterviewScheduleTime={setSearchInterviewScheduleTime}
                searchInterviewScheduleLocation={
                  searchInterviewScheduleLocation
                }
                setSearchInterviewScheduleLocation={
                  setSearchInterviewScheduleLocation
                }
                searchInterviewScheduleLink={searchInterviewScheduleLink}
                setSearchInterviewScheduleLink={setSearchInterviewScheduleLink}
                searchJoinDate={searchJoinDate}
                setSearchJoinDate={setSearchJoinDate}
                searchSubmissionBy={searchSubmissionBy}
                setSearchSubmissionBy={setSearchSubmissionBy}
                searchEmail={searchEmail}
                setSearchEmail={setSearchEmail}
                searchContactName={searchContactName}
                setSearchContactName={setSearchContactName}
                searchActualCTC={searchActualCTC}
                setSearchActualCTC={setSearchActualCTC}
                searchOfferCTC={searchOfferCTC}
                setSearchOfferCTC={setSearchOfferCTC}
                searchExpectedJoinDate={searchExpectedJoinDate}
                setSearchExpectedJoinDate={setSearchExpectedJoinDate}
                searchUpdatedBy={searchUpdatedBy}
                setSearchUpdatedBy={setSearchUpdatedBy}
                searchFullName={searchFullName}
                setSearchFullName={setSearchFullName}
                isFilterActiveFname={isFilterActiveFname}
                isFilterActiveFullName={isFilterActiveFullName}
                isFilterActiveUpdatedBy={isFilterActiveUpdatedBy}
                isFilterActiveExpectedJoinDate={isFilterActiveExpectedJoinDate}
                isFilterActiveUpdatedDate={isFilterActiveUpdatedDate}
                isFilterActiveOfferCTC={isFilterActiveOfferCTC}
                isFilterActiveActualCTC={isFilterActiveActualCTC}
                isFilterActiveEmail={isFilterActiveEmail}
                isFilterActiveSubmissionBy={isFilterActiveSubmissionBy}
                isFilterActiveJoinDate={isFilterActiveJoinDate}
                isFilterActiveInterviewScheduleLink={
                  isFilterActiveInterviewScheduleLink
                }
                isFilterActiveInterviewScheduleLocation={
                  isFilterActiveInterviewScheduleLocation
                }
                isFilterActiveInterviewScheduleTime={
                  isFilterActiveInterviewScheduleTime
                }
                isFilterActiveInterviewScheduleDate={
                  isFilterActiveInterviewScheduleDate
                }
                isFilterActiveGender={isFilterActiveGender}
                isFilterActiveExperience={isFilterActiveExperience}
                isFilterActiveEducationDetails={isFilterActiveEducationDetails}
                isFilterActiveWorkExperience={isFilterActiveWorkExperience}
                isFilterActiveDesignation={isFilterActiveDesignation}
                isFilterActivePanCardNumber={isFilterActivePanCardNumber}
                isFilterActiveAadharCardNumber={isFilterActiveAadharCardNumber}
                isFilterActiveDOB={isFilterActiveDOB}
                isFilterActiveAddress={isFilterActiveAddress}
                isFilterActivePhone={isFilterActivePhone}
                isFilterActiveNoticePeriod={isFilterActiveNoticePeriod}
                isFilterActivEexpectedCtctype={isFilterActivEexpectedCtctype}
                isFilterActiveExpectedCtc={isFilterActiveExpectedCtc}
                isFilterActiveLname={isFilterActiveLname}
                isFilterActiveJobt={isFilterActiveJobt}
                isFilterActiveStatus={isFilterActiveStatus}
                isFilterActiveClient={isFilterActiveClient}
                isFilterActiveOwner={isFilterActiveOwner}
                isFilterActiveCtctype={isFilterActiveCtctype}
                isFilterActiveCtc={isFilterActiveCtc}
                isFilterActiveCity={isFilterActiveCity}
                isFilterActiveState={isFilterActiveState}
                isFilterActiveDate={isFilterActiveDate}
                isFilterActiveContactName={isFilterActiveContactName}
                setIsFilterActiveSubmissionBy={setIsFilterActiveSubmissionBy}
                filterData={filterData}
                setMySubmissionValue={setMySubmissionValue}
                mySubmissionValue={mySubmissionValue}
                handleFilterAllFieldStep={handleFilterAllFieldStep}
                popoverVisible={popoverVisible}
                setPopoverVisible={setPopoverVisible}
                handlePopOverClose={handlePopOverClose}
                industries={industries}
                setSearchIndustry={setSearchIndustry}
                searchIndustry={searchIndustry}
                isFilterActiveIndustry={isFilterActiveIndustry}
                handleActivitySubmit={handleCandidateActivitySubmit}
                searchInterviewRescheduleDate={searchInterviewRescheduleDate}
                setSearchInterviewRescheduleDate={
                  setSearchInterviewRescheduleDate
                }
                isFilterActiveInterviewRescheduleDate={
                  isFilterActiveInterviewRescheduleDate
                }
                searchTestRescheduleDate={searchTestRescheduleDate}
                setSearchTestRescheduleDate={setSearchTestRescheduleDate}
                isFilterActiveTestRescheduleDate={
                  isFilterActiveTestRescheduleDate
                }
                searchBackoutDate={searchBackoutDate}
                setSearchBackoutDate={setSearchBackoutDate}
                isFilterActiveBackoutDate={isFilterActiveBackoutDate}
                isFilterActiveSourceSearch={isFilterActiveSourceSearch}
                searchSourceData={searchSourceData}
                setSearchSourceData={setSearchSourceData}
                setIsFilterActiveBranch={setIsFilterActiveBranch}
                isFilterActiveBranch={isFilterActiveBranch}
                setSearchBranch={setSearchBranch}
                searchBranch={searchBranch}
              />
              <CustomizeColumns
                ViewSubmheaderOrders={ViewSubmheaderOrders}
                handleSubmHeaderOrdersClose={handleSubmHeaderOrdersClose}
                onDragEnd={onDragEnd}
                displaySubmheaderOrders={displaySubmheaderOrders}
                defaultDisplaySubmHeaderOrders={defaultDisplaySubmHeaderOrders}
                handleCheckboxChange={handleCheckboxChange}
                handleApplyClick={handleApplyClick}
              />

              {/* Modal for Candidate Note creation */}
              <NoteSubmissionModel
                candidateNote={candidateNote}
                handleCandidateNoteClose={handleCandidateNoteClose}
                searchNote={searchNote}
                getnotes={getnotes}
                setSearchNote={setSearchNote}
                setNote={setNote}
                note={note}
                setGetNotes={setGetNotes}
                // getJobpostdata={getCandidateSubmission}
                getJobpostdata={filterJobpostData}
                page={page}
                rowsPerPage={rowsPerPage}
                moduleData={submissionModuleData}
                getCandidate={getCandidate}
                setNotesLoading={setNotesLoading}
                notesLoading={notesLoading}
              />

              <CustomizeColumns
                ViewSubmheaderOrders={isOpen}
                handleSubmHeaderOrdersClose={handleCloseModal}
                onDragEnd={onDragEnd}
                displaySubmheaderOrders={displaySubmheaderOrders}
                defaultDisplaySubmHeaderOrders={defaultDisplaySubmHeaderOrders}
                handleCheckboxChange={handleCheckboxChange}
                handleApplyClick={exportSubmissions}
                candidates={displaycandidateSubmission}
                filename={filename}
                Changeoption={handleApplyClick}
              />

              {/* Modal for Edit Submission */}

              {/* Modal for Delete Submission */}
              <DeleteModal
                ViewDelete={removeSubmission}
                title={"Delete Submission"}
                handleDeleteClose={handleRemoveSubmissionClose}
                handleDelete={handleDeleteSubmission}
              />
              {/* Modal for Submission Preview */}
              <ResumePreviewModal
                preview={submissionPreview}
                handlePreviewClose={handleSubmissionPreviewClose}
                objectURL={objectURL?.filePath || resumeFilePath}
                submission={submission}
                resumeFilePath={resumeFilePath}
                firstName={candidate?.firstName}
                lastName={candidate?.lastName}
                phone={candidate?.phone}
                email={candidate?.email}
                fileName={candidate?.fileName}
                action={() => {
                  handleCandidateNoteShow();
                  setNote({
                    ...note,
                    candidateId: submission?.candidateId?._id,
                  });
                  getCandidatNotes(submission?.candidateId?._id);

                }}
              />
              <ComposeMailForm
                ViewSendMail={ViewSendMail}
                handleSendMailClose={handleSendMailClose}
                SetToemail={SetToemail}
                SetCcemail={SetCcemail}
                SetBccemail={SetBccemail}
                SetSubject={SetSubject}
                SetMailMessage={SetMailMessage}
                checked={checked}
                endPoint={"/api/SelectCandidate_EmailSend"}
              />

              {/* Modal for Edit Submission Status*/}

              <EditSubmissionStatusModel
                editSubmissionStatus={editSubmissionStatus}
                handleEditSubmissionStatusClose={
                  handleEditSubmissionStatusClose
                }
                submission={submission}
                handleInputs={handleSubmInputs}
                applicationStatus={applicationStatus}
                handleUpdateStatus={handleEditSubmissionStatus}
                handleEditShow={handleEditSubmissionShow}
                SetEditSubmissionStatus={SetEditSubmissionStatus}
              />
            </TabPanel>

            <TabPanel>
              {activity?.map((value, index) => (
                <>
                  <MDBContainer>
                    <ul className="timeline">
                      <li className="timeline-item">
                        <h5 className="activitytitle">{value.jobActivity}</h5>
                        {(value && value?.submittedBy || value?.submittedById?.firstName)
                          && (
                            <h5 className="activitytitle">
                              By :
                              {value?.submittedBy ||
                                value?.submittedById?.firstName +
                                " " +
                                value?.submittedById?.lastName}
                            </h5>
                          )}
                        <p className="activityinfo">
                          {
                            new Date(value.created_at)
                              .toLocaleString()
                              ?.split(",")[0]
                          }
                          <br />
                          {
                            new Date(value.created_at)
                              .toLocaleString()
                              ?.split(",")[1]
                          }
                        </p>
                      </li>
                    </ul>
                  </MDBContainer>
                </>
              ))}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
      {/* Modal for Search Job */}

      <SearchJobModel
        searchJobModel={searchJob}
        searchJobId={searchJobId}
        setSearchJobId={setSearchJobId}
        isFilterActiveJobId={isFilterActiveJobId}
        handleCreateSubmissionClose={handleCreateSubmissionClose}
        searchjob={searchjob}
        setSearchJob={setSearchJob}
        filterJobpostData={filterJobpostData}
        loading={searchJobLoading}
        jobposts={jobposts}
        setSubmission={setSubmission}
        setJobScreeningId={setJobScreeningId}
        Setjobtitle={Setjobtitle}
        handleSubmitSubmissionShow={handleSubmitSubmissionShow}
        rowsPerSubmissionPage={rowsPerSubmissionPage}
        submissionpage={submissionpage}
        handleChangeSubmissionPage={handleChangeSubmissionPage}
        handleChangeRowsPerSubmissionPage={handleChangeRowsPerSubmissionPage}
        submission={submission?.email ? submission : null}
        jobtitle={jobtitle}
        candidateId={candidate?._id || submission?.candidateId}
        clearFilter={clearJobFilter}
        jobSearchActiveField={jobSearchActiveField}
        setJobSearchActiveField={setJobSearchActiveField}
        searchJobTitle={searchJobTitle}
        setSearchJobTitle={setSearchJobTitle}
        searchJobContactName={searchJobContactName}
        setSearchJobContactName={setSearchJobContactName}
        searchJobClient={searchJobClient}
        setSearchJobBranch={setSearchJobBranch}
        searchJobBranch={searchJobBranch}
        setSearchJobClient={setSearchJobClient}
        searchJobCity={searchJobCity}
        setSearchJobCity={setSearchJobCity}
        setSearchJobOwner={setSearchJobOwner}
        searchJobOwner={searchJobOwner}
      />

      {/* Modal for Submit Submission */}

      <Submissionform
        // getAllSubmissiondata={getCandidateSubmission}
        handleInputs={handleSubmInputs}
        show={true}
        setCandidate={setCandidate}
        applicationStatus={applicationStatus}
        candidateStatus={submission?.status}
        getAllSubmissiondata={handleFilterAllFieldStep}
        saveFile={saveSubmFile}
        handleSubmitSubmissionClose={handleSubmitSubmissionClose}
        submitSubmission={submitSubmission}
        submission={submission}
        setSubmission={setSubmission}
        handleCreateSubmissionClose={handleCreateSubmissionClose}
        handleActivitySubmit={handleActivitySubmit}
        handleCandidateActivitySubmit={handleCandidateActivitySubmit}
        candidatename={candidate}
        jobtitle={jobtitle}
        id={resumeid}
        setId={setId}
        handleEditShow={handleEditShow}
        editSubmission={editSubmission}
        handleEditClose={handleEditClose}
        handleAppliedJobClientEmailSend={handleAppliedJobClientEmailSend}
        handleAppliedJobEmailSend={handleAppliedJobEmailSend}
        handleResumeMatching={handleResumeMatching}
        matchingSkills={matchingSkills}
        ParsedSkills={ParsedSkills}
        missingSkills={missingSkills}
        router={router}
        parsePercentage={parsePercentage}
        parseAge={parseAge}
        parseResumeConclusion={parseResumeConclusion}
        loadingResumeScreening={loadingResumeScreening}
        component="candidate"
        moduleData={submissionModuleData}
      />

      {/* Modal for Edit Candidate */}
      <EditCandidateModal
        ViewEdit={ViewEdit}
        handleEditClose={handleEditClose}
        editFormik={editCandidateFormik}
        saveFile={saveFile}
        // parseSummary={parseSummary}
        resumeFilePath={resumeFilePath}
        toggleResumeDetails={toggleResumeDetails}
        showResumeDetails={showResumeDetails}
        // setParsedata={setParsedata}
        file={file}
        setCandidateNote={setCandidateNote}
        Country={Country}
        setSelectedCountry={setSelectedCountry}
        setCandidate={setCandidate}
        applicationStatus={applicationStatus}
        sourceData={sourceData}
        candidateStatus={candidateStatus}
        handleAddEducation={handleAddEducation}
        eductionFields={eductionFields}
        setEductionFields={setEductionFields}
        handleFormChange={handleFormChange}
        handleAddWork={handleAddWork}
        workExperienceFields={workExperienceFields}
        setWorkexperienceFields={setWorkexperienceFields}
        handleFormWorkChange={handleFormWorkChange}
        setSelectedWorkCountry={setSelectedWorkCountry}
        handleFormWorkExpChange={handleFormWorkExpChange}
        setSelectedWorkState={setSelectedWorkState}
        setSelectedorkCity={setSelectedorkCity}
        handleAddReference={handleAddReference}
        referenceFields={referenceFields}
        setReferenceFields={setReferenceFields}
        handleFormReferenceChange={handleFormReferenceChange}
        // setSendMail={setSendMail}
        // sendMail={sendMail}
        // handleDelete={handleDelete}
        selectedCountry={selectedCountry}
        selectedWorkCountry={selectedWorkCountry}
        selectedWorkState={selectedWorkState}
        selectedWorkCity={selectedWorkCity}
        candidateLoading={candidateLoading}
        candidate={candidate}
        setSelectedState={setSelectedState}
        selectedState={selectedState}
        setSelectedCity={setSelectedCity}
        selectedCity={selectedCity}
        industries={industries}
        parsedObjectives={parsedObjectives}
      />

      {loading ? <div className="loader_import"></div> : null}
    </Box>
  );
}

export default Candidateview;
